!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).basicLightbox=e()}}((function(){return function e(n,t,o){function r(c,u){if(!t[c]){if(!n[c]){var s="function"==typeof require&&require;if(!u&&s)return s(c,!0);if(i)return i(c,!0);var a=new Error("Cannot find module '"+c+"'");throw a.code="MODULE_NOT_FOUND",a}var l=t[c]={exports:{}};n[c][0].call(l.exports,(function(e){return r(n[c][1][e]||e)}),l,l.exports,e,n,t,o)}return t[c].exports}for(var i="function"==typeof require&&require,c=0;c<o.length;c++)r(o[c]);return r}({1:[function(e,n,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.create=t.visible=void 0;var o=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],t=document.createElement("div");return t.innerHTML=e.trim(),!0===n?t.children:t.firstChild},r=function(e,n){var t=e.children;return 1===t.length&&t[0].tagName===n},i=function(e){return null!=(e=e||document.querySelector(".basicLightbox"))&&!0===e.ownerDocument.body.contains(e)};t.visible=i;t.create=function(e,n){var t=function(e,n){var t=o('\n\t\t<div class="basicLightbox '.concat(n.className,'">\n\t\t\t<div class="basicLightbox__placeholder" role="dialog"></div>\n\t\t</div>\n\t')),i=t.querySelector(".basicLightbox__placeholder");e.forEach((function(e){return i.appendChild(e)}));var c=r(i,"IMG"),u=r(i,"VIDEO"),s=r(i,"IFRAME");return!0===c&&t.classList.add("basicLightbox--img"),!0===u&&t.classList.add("basicLightbox--video"),!0===s&&t.classList.add("basicLightbox--iframe"),t}(e=function(e){var n="string"==typeof e,t=e instanceof HTMLElement==1;if(!1===n&&!1===t)throw new Error("Content must be a DOM element/node or string");return!0===n?Array.from(o(e,!0)):"TEMPLATE"===e.tagName?[e.content.cloneNode(!0)]:Array.from(e.children)}(e),n=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(null==(e=Object.assign({},e)).closable&&(e.closable=!0),null==e.className&&(e.className=""),null==e.onShow&&(e.onShow=function(){}),null==e.onClose&&(e.onClose=function(){}),"boolean"!=typeof e.closable)throw new Error("Property `closable` must be a boolean");if("string"!=typeof e.className)throw new Error("Property `className` must be a string");if("function"!=typeof e.onShow)throw new Error("Property `onShow` must be a function");if("function"!=typeof e.onClose)throw new Error("Property `onClose` must be a function");return e}(n)),c=function(e){return!1!==n.onClose(u)&&function(e,n){$("html,body,#site-overlay").css("overflow","revert"); return e.classList.remove("basicLightbox--visible"),setTimeout((function(){return!1===i(e)||e.parentElement.removeChild(e),n()}),410),!0}(t,(function(){if("function"==typeof e)return e(u)}))};!0===n.closable&&t.addEventListener("click",(function(e){e.target===t&&c()}));var u={element:function(){return t},visible:function(){return i(t)},show:function(e){return!1!==n.onShow(u)&&function(e,n){return document.body.appendChild(e),setTimeout((function(){requestAnimationFrame((function(){return e.classList.add("basicLightbox--visible"),n()}))}),10),!0}(t,(function(){if("function"==typeof e)return e(u)}))},close:c};return u}},{}]},{},[1])(1)}));
!function(){"use strict";function o(){var o=window,t=document;if(!("scrollBehavior"in t.documentElement.style&&!0!==o.__forceSmoothScrollPolyfill__)){var l,e=o.HTMLElement||o.Element,r=468,i={scroll:o.scroll||o.scrollTo,scrollBy:o.scrollBy,elementScroll:e.prototype.scroll||n,scrollIntoView:e.prototype.scrollIntoView},s=o.performance&&o.performance.now?o.performance.now.bind(o.performance):Date.now,c=(l=o.navigator.userAgent,new RegExp(["MSIE ","Trident/","Edge/"].join("|")).test(l)?1:0);o.scroll=o.scrollTo=function(){void 0!==arguments[0]&&(!0!==f(arguments[0])?h.call(o,t.body,void 0!==arguments[0].left?~~arguments[0].left:o.scrollX||o.pageXOffset,void 0!==arguments[0].top?~~arguments[0].top:o.scrollY||o.pageYOffset):i.scroll.call(o,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:o.scrollX||o.pageXOffset,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:o.scrollY||o.pageYOffset))},o.scrollBy=function(){void 0!==arguments[0]&&(f(arguments[0])?i.scrollBy.call(o,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:0,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:0):h.call(o,t.body,~~arguments[0].left+(o.scrollX||o.pageXOffset),~~arguments[0].top+(o.scrollY||o.pageYOffset)))},e.prototype.scroll=e.prototype.scrollTo=function(){if(void 0!==arguments[0])if(!0!==f(arguments[0])){var o=arguments[0].left,t=arguments[0].top;h.call(this,this,void 0===o?this.scrollLeft:~~o,void 0===t?this.scrollTop:~~t)}else{if("number"==typeof arguments[0]&&void 0===arguments[1])throw new SyntaxError("Value could not be converted");i.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left:"object"!=typeof arguments[0]?~~arguments[0]:this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top:void 0!==arguments[1]?~~arguments[1]:this.scrollTop)}},e.prototype.scrollBy=function(){void 0!==arguments[0]&&(!0!==f(arguments[0])?this.scroll({left:~~arguments[0].left+this.scrollLeft,top:~~arguments[0].top+this.scrollTop,behavior:arguments[0].behavior}):i.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left+this.scrollLeft:~~arguments[0]+this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top+this.scrollTop:~~arguments[1]+this.scrollTop))},e.prototype.scrollIntoView=function(){if(!0!==f(arguments[0])){var l=function(o){for(;o!==t.body&&!1===(e=p(l=o,"Y")&&a(l,"Y"),r=p(l,"X")&&a(l,"X"),e||r);)o=o.parentNode||o.host;var l,e,r;return o}(this),e=l.getBoundingClientRect(),r=this.getBoundingClientRect();l!==t.body?(h.call(this,l,l.scrollLeft+r.left-e.left,l.scrollTop+r.top-e.top),"fixed"!==o.getComputedStyle(l).position&&o.scrollBy({left:e.left,top:e.top,behavior:"smooth"})):o.scrollBy({left:r.left,top:r.top,behavior:"smooth"})}else i.scrollIntoView.call(this,void 0===arguments[0]||arguments[0])}}function n(o,t){this.scrollLeft=o,this.scrollTop=t}function f(o){if(null===o||"object"!=typeof o||void 0===o.behavior||"auto"===o.behavior||"instant"===o.behavior)return!0;if("object"==typeof o&&"smooth"===o.behavior)return!1;throw new TypeError("behavior member of ScrollOptions "+o.behavior+" is not a valid value for enumeration ScrollBehavior.")}function p(o,t){return"Y"===t?o.clientHeight+c<o.scrollHeight:"X"===t?o.clientWidth+c<o.scrollWidth:void 0}function a(t,l){var e=o.getComputedStyle(t,null)["overflow"+l];return"auto"===e||"scroll"===e}function d(t){var l,e,i,c,n=(s()-t.startTime)/r;c=n=n>1?1:n,l=.5*(1-Math.cos(Math.PI*c)),e=t.startX+(t.x-t.startX)*l,i=t.startY+(t.y-t.startY)*l,t.method.call(t.scrollable,e,i),e===t.x&&i===t.y||o.requestAnimationFrame(d.bind(o,t))}function h(l,e,r){var c,f,p,a,h=s();l===t.body?(c=o,f=o.scrollX||o.pageXOffset,p=o.scrollY||o.pageYOffset,a=i.scroll):(c=l,f=l.scrollLeft,p=l.scrollTop,a=n),d({scrollable:c,method:a,startTime:h,startX:f,startY:p,x:e,y:r})}}"object"==typeof exports&&"undefined"!=typeof module?module.exports={polyfill:o}:o()}();
class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.filterData = [];
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

		if ( ! this.classList.contains('don-t-duplicate') ) {

			document.getElementById('FacetFiltersFormMobile').innerHTML = document.getElementById('FacetFiltersForm').innerHTML;
			document.getElementById('FacetFiltersFormMobile').addEventListener('input', this.debouncedOnSubmit.bind(this));
			document.getElementById('FacetFiltersFormMobile').querySelectorAll('.facets__item').forEach(elm=>{
				const id = elm.querySelector('input').id;
				elm.querySelector('label').setAttribute('for', `mobile-${id}`);
				elm.querySelector('input').id = `mobile-${id}`;
			});
			document.getElementById('FacetFiltersFormMobile').querySelector('.active-facets').classList.remove('active-facets-desktop')
			document.getElementById('FacetFiltersFormMobile').querySelector('.active-facets').classList.add('active-facets-mobile');
		}

	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		}
		window.addEventListener('popstate', onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach((element) => {
			element.classList.toggle('disabled', disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
      
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		document.getElementById('main-collection-product-grid').classList.add('loading');
		sections.forEach((section) => {
			let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			let filterDataUrl = element => element.url === url;

            console.log( url, filterDataUrl );
          
			FacetFiltersForm.filterData.some(filterDataUrl) ?
				FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
				FacetFiltersForm.renderSectionFromFetch(url, event);
		});
		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then(response => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGrid(html);
				FacetFiltersForm.renderProductCount(html);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGrid(html);
		FacetFiltersForm.renderProductCount(html);
	}

	static renderProductGrid(html) {
		const innerHTML = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('CollectionProductGrid').innerHTML;
		document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
		window.preloadImages(document.getElementById('CollectionProductGrid'));
	}

	static renderProductCount(html) {
		const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount');
		if ( countEl ) {
			document.getElementById('CollectionProductCount').innerHTML = countEl.innerHTML;
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		const facetDetailsElements =
			parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
		const matchesIndex = (element) => {
			if ( event && event.target.closest('.js-filter') ) {
				return element.dataset.index === event.target.closest('.js-filter').dataset.index;
			}
		}
		const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);

		if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector('.active-facets');
			if (!activeFacetsElement) return;
			if ( document.querySelector(selector) )
				document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
		})

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderCounts(source, target) {
		const countElementSelectors = ['.facets__selected'];
		countElementSelectors.forEach((selector) => {
			const targetElement = target.querySelector(selector);
			const sourceElement = source.querySelector(selector);
			if (sourceElement && targetElement) {
				target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
			}
		});
	}

    static hideAllFiltersExceptActive() {
    	const filters = document.querySelectorAll('.js-filter');
    	filters.forEach(filter => {
    		const activeOption = filter.querySelector('input[type="checkbox"]:checked');
    		if (!activeOption) {
    			filter.style.display = 'none'; // or use a class to hide
    		}
    	});
    }


	static updateURLHash(searchParams) {
		history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
	}

	static getSections() {
		return [
			{
				id: 'main-collection-product-grid',
				section: document.getElementById('main-collection-product-grid').dataset.id,
			}
		]
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const formData = new FormData(event.target.closest('form'));
		let searchParams = new URLSearchParams(formData).toString();
        if (searchParams.includes('filter.p.m.rf-product.ecommerce=B') && !searchParams.includes('filter.v.availability=')) {
            searchParams += '&filter.v.availability=1';
        }
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
	}

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		this.querySelector('a').addEventListener('click', (event) => {
			event.preventDefault();
			const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
			form.onActiveFilterClick(event);
		});
	}
}

customElements.define('facet-remove', FacetRemove);




class FinishSwatchLibrary extends HTMLElement {
	constructor() {
		super()

		this.swatchQueryParam 	= 'swatch_id'

		this.activeSwatchId		= null
		this.activeSwatchHandle	= null
		this.activeSwatchTitle 	= null

		this.popupIsOpen 		= false

		this.swatchGroups		= this.querySelectorAll('.js-swatch-group')
		this.swatchBtns			= this.querySelectorAll('.js-swatch-btn')

		this.bind()
	}


	bind() {
		document.addEventListener( 'DOMContentLoaded', e => {
			this.initializeMagnific()
			this.maybeLoadSwatch()
		})

		window.addEventListener( 'webfx:swatch:click', e => {
			const swatchId = e.detail?.swatchId

			if( 'string' === typeof swatchId && swatchId.length ) {
				this.manuallyTriggerSwatch( swatchId )
			}
		})
	}


	initializeMagnific() {
		const self = this

		self.swatchGroups.forEach( el => {
			$(el).magnificPopup({
				delegate:	'.js-swatch-btn',
				type: 		'image',
				gallery: 	{
					enabled: true,
				},
				image: {
					titleSrc({ el }) { // el is a jQuery obj
						return el.data( 'swatch-title' )
					}
				},
				callbacks: {
					open() {
						self.setActiveSwatch( this.currItem.el.get( 0 ) ) // el is a jQuery obj
						self.handlePopupOpen()
					},
					change() {
						self.setActiveSwatch( this.currItem.el.get( 0 ) ) // el is a jQuery obj
					},
					close() {
						self.clearQueryParam()
						self.handlePopupClose()
					}
				}
			})
		})
	}


	setActiveSwatch( swatch ) {
		this.activeSwatchId		= swatch.dataset.swatchId
		this.activeSwatchHandle	= swatch.dataset.swatchHandle
		this.activeSwatchTitle 	= swatch.dataset.swatchTitle

		this.popuplateQueryParam( this.activeSwatchId )
	}


	getQueryParam() {
		const url = new URL( window.location )

		if( url.searchParams.has( this.swatchQueryParam ) ) {
			return url.searchParams.get( this.swatchQueryParam )
		}

		return null
	}


	clearQueryParam() {
		const url = new URL( window.location )

		url.searchParams.delete( this.swatchQueryParam )

		window.history.replaceState( {}, '', url.toString() );
	}


	popuplateQueryParam( value ) {
		const url = new URL( window.location )

		url.searchParams.set( this.swatchQueryParam, value )

		window.history.replaceState( {}, '', url.toString() );
	}


	maybeLoadSwatch( e ) {
		if( this.popupIsOpen ) {
			return
		}

		const queryParam = this.getQueryParam()

		if( 'string' === typeof queryParam && queryParam.length ) {
			this.manuallyTriggerSwatch( queryParam )
		}
	}


	manuallyTriggerSwatch( targetSwatchId ) {
		for( const btn of this.swatchBtns ) {
			const btnId = btn.dataset.swatchId
	
			if( btnId === targetSwatchId ) {
				btn.click()
				break
			}
		}
	}


	handlePopupOpen() {
		this.popupIsOpen = true
	}


	handlePopupClose() {
		this.popupIsOpen = false
	}

}
customElements.define( 'finish-swatch-library', FinishSwatchLibrary )
class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input')
			.forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute('max', maxInput.value);
		if (minInput.value) maxInput.setAttribute('min', minInput.value);
		if (minInput.value === '') maxInput.setAttribute('min', 0);
		if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute('min'));
		const max = Number(input.getAttribute('max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define('price-range', PriceRange);
class LocalizationForm extends HTMLElement {

	constructor(){

		super();

		this.selector = this.querySelector('.regular-select-cover');
		this.content = this.querySelector('.regular-select-content');

		this.selector.addEventListener('click', e=>{

			e.stopPropagation();
			e.preventDefault();

			document.querySelectorAll('.regular-select-cover.content-opened').forEach(elm=>{
				if ( elm != e.currentTarget ) {
					elm.classList.remove('content-opened');
					elm.parentNode.style.zIndex = 9;
				}
			});

			if ( ! this.content.classList.contains('content-opened') ) {

				this.content.classList.add('content-opened');
				e.currentTarget.setAttribute('aria-expanded', 'true');
				this.content.parentNode.style.zIndex = 1000;;

				if ( this.content.classList.contains('invert-with-fixed') ) {
					if ( this.content.getBoundingClientRect().y + this.content.outerHeight + 55 > window.innerHeight ) {
						this.content.classList.add('invert');
					}
				} else {
					if ( this.content.offsetTop + this.content.outerHeight + 55 > document.querySelector('html').outerHeight ) {
						this.content.classList.add('invert');
					}
				}

				this.onClickHandler = (()=>{
					if ( this.content.classList.contains('content-opened') ) {
						this.content.classList.remove('content-opened', 'invert');
						this.content.parentNode.style.zIndex = 9;
					}
				}).bind(this);
				window.addEventListener('click', this.onClickHandler);

			} else {
				e.currentTarget.setAttribute('aria-expanded', 'false');
				this.content.parentNode.style.zIndex = 9;
				this.content.classList.remove('content-opened', 'invert');
				window.removeEventListener('click', this.onClickHandler);
			}

		});

		this.querySelector('.regular-select-cover').addEventListener('keydown', function(e){
			if ( e.keyCode == window.KEYCODES.RETURN ) {
				if ( ! this.content.classList.contains('opened-with-tab') ) {
					this.content.classList.add('opened-with-tab');
					this.content.querySelectorAll('.regular-select-item').forEach(elm=>{elm.setAttribute('tabindex', '0')});
				}
			}
		});

	}

}

customElements.define('localization-form', LocalizationForm);
class ModalBox extends HTMLElement {

	constructor() {

		super();

		this.o = {
			...{
				show: 10, 
				frequency: 'day', 
				enabled: true
			}, ...JSON.parse(this.dataset.options)
		};

		this._modalKey = `modal-${document.location.hostname}-${this.id}`;
		this._modalStorage = ! localStorage.getItem(this._modalKey) ? 'empty' : JSON.parse(localStorage.getItem(this._modalKey));
		this._modalText = this.extractText(this.querySelector('[data-content]'));

		if ( this.o.enabled ) {

			const timeNow = new Date().getTime();
			const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);
			let showModal = false;

			if ( this._modalStorage == 'empty'
				|| ( this.frequency == 'day' && inBetween > 86400 )
				|| ( this.frequency == 'week' && inBetween > 604800 )
				|| ( this.frequency == 'month' && inBetween > 2419200 )
				|| this._modalStorage['content'] != this._modalText
			 ) {
				showModal = true
			}

			if ( showModal ) {
				setTimeout(()=>{
					this.show();
				}, parseInt(this.o.show*1000));
				setTimeout(()=>{
					this.querySelectorAll('[data-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(true)}));
				}, 100);
			}

		}
		
		this.setAttribute('style', '');

	}

	show(){
		window.preloadImages(this);
		this.classList.add('active');
	}
	hide(remember=false){
		this.classList.remove('active');
		if ( remember && ! Shopify.designMode ){
			localStorage.setItem(this._modalKey, JSON.stringify({
				'shown': (new Date().getTime()),
				'content': this._modalText
			}));
		}
	}

	extractText(content){
		let span = document.createElement('span');
		span.innerHTML= content.innerHTML;
		const returnText = span.textContent || span.innerText;
		span.remove();
		return [returnText].toString().replace(/ +/g,'');
	}

}
customElements.define('modal-box', ModalBox);

// Shopify events

document.addEventListener('shopify:section:select', (e)=>{
	if ( e.target.classList.contains('mount-popup') ) {
		e.target.querySelector('modal-box').show();
	}
});
document.addEventListener('shopify:section:deselect', (e)=>{
	if ( e.target.classList.contains('mount-popup') ) {
		e.target.querySelector('modal-box').hide();
	}
});
class ProductVariants extends HTMLElement {

	constructor() {

		super();
		this.price = document.querySelector(`#product-price-${this.dataset.id}`);

		if ( this.price ) {
			this.priceOriginal = document.querySelector('.product__price--original');
			this.priceCompare = document.querySelector('.product__price--compare');
			this.priceUnit = document.querySelector('.product__price--unit');
		}

		this.productForm = document.querySelector(`#product-form-${this.dataset.id}`);
		
		if ( this.productForm ) {
			this.productQty = document.querySelector('.product__quantity');
			this.addToCart = document.querySelector('.product__add-to-cart');
			this.addToCartText = document.querySelector('.add-to-cart__text');
		}

		this.productSKU = document.querySelector(`#product-${this.dataset.id} .product__sku`);
		this.productBARCODE = document.querySelector(`#product-${this.dataset.id} .product__barcode`);

		this.addEventListener('change', this.onVariantChange);

		this.updateOptions();
		this.updateMasterId();
		this.updateUnavailableVariants();

		this.productStock = this.querySelector('.variant-quantity');
		if ( this.productStock && this.querySelector('.variant-quantity-data') ) {
			this.productStockData = JSON.parse(this.querySelector('.variant-quantity-data').dataset.inventory);
		}
		this.updateStock();

		this._event = new Event('VARIANT_CHANGE');

	}

	onVariantChange(){

		this.updateOptions();
		this.updateMasterId();
		this.updateVariantInput();
		if ( this.price ) {
			this.updatePrice();
		}
		this.updateStock();
		this.updateUnavailableVariants();
		this.updatePickupAvailability();
		if ( ! this.hasAttribute('data-no-history') ) {
			this.updateURL();
		}
		this.updateDetails();

		const nodeInvalidVariantText = this.querySelector('.invalid-variant')

		nodeInvalidVariantText.classList.add( 'hide' )
		nodeInvalidVariantText.innerText = ''
        var shouldDisableCart = false;
		if ( this.productForm ) {
			if ( ! this.currentVariant || ! this.currentVariant.available ) {
				if ( this.productQty ) this.productQty.style.display = 'none';
				this.addToCart.classList.add('disabled');
				this.productForm.classList.add('disabled-cart');
				this.addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
              shouldDisableCart = true;
			} else {
				if ( this.productQty ) this.productQty.style.display = '';
				this.addToCart.classList.remove('disabled');
				this.productForm.classList.remove('disabled-cart');
				this.addToCartText.textContent = KROWN.settings.locales.products_add_to_cart_button;
			}

			if ( ! this.currentVariant ) {
				nodeInvalidVariantText.innerText = 'No products match the selected options. Please try selecting different options.'
				nodeInvalidVariantText.classList.remove( 'hide' )

				this.productForm.classList.add('unavailable-variant');
				this.addToCartText.textContent = KROWN.settings.locales.products_unavailable_variant;
              shouldDisableCart = true;
			} else {
				this.productForm.classList.remove('unavailable-variant');
			}

              // WEBFX - added 11/15/2023 
              // Ensure that the add to cart button is not clickable unless it's valid. 
              var currentCartText = jQuery('.product__add-to-cart .add-to-cart__text').text();

              if (shouldDisableCart && (currentCartText === "Sold out" || currentCartText === "Unavailable")) {
                jQuery('.product__add-to-cart.product--add-to-cart-button.js-add-to-cart-btn').prop('disabled', true);
                
              } else {
                // Just insurance make sure the button disabled attribute is removed. 
                jQuery('.product__add-to-cart.product--add-to-cart-button.js-add-to-cart-btn').prop('disabled', false);
              }
		}

		this.dispatchEvent(this._event);

		// 2023-06-23 :: WebFX - Rob :: moved to updateMasterId instead
		// const cylindoEvent = new CustomEvent( 'rf:product:variantChange', {
		// 	detail: {
		// 		activeVariantOptions: this.options
		// 	}
		// })

		// document.dispatchEvent( cylindoEvent )
	}

	updateOptions(){
		if ( this.dataset.type == 'select' ) {
			this.options = Array.from(this.querySelectorAll('.product-variant-container'), (select) => select.value);
		} else if ( this.dataset.type == 'radio' ) {
			this.options = [];
			this.querySelectorAll('.product-variant__input').forEach(elm=>{
				if ( elm.checked ) 
					this.options.push(elm.value);
			});
		}
	}

	updateMasterId(){
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options.map((option, index) => {
				return this.options[index] === option;
			}).includes(false);
		});

		// for product Cylindo switchout
		// for deposit/disclaimer speedbump
		const variantChangeEvent = new CustomEvent( 'rf:product:variantChange', {
			detail: {
				activeVariant: this.currentVariant, // added 2023-06-23
				activeVariantOptions: this.currentVariant?.options ?? []
			}
		})

		document.dispatchEvent( variantChangeEvent )
	}

	updatePrice(){
		
		if (!this.currentVariant) {
			this.priceOriginal.innerHTML = '';
			this.priceCompare.style.display = 'none';
			this.priceUnit.innerHTML = '';
		} else {
		
			this.priceOriginal.innerHTML = KROWN.helpers.formatMoney(this.currentVariant.price, KROWN.settings.shop_money_format);
			if ( this.currentVariant.compare_at_price > this.currentVariant.price ) {
				this.priceCompare.innerHTML = KROWN.helpers.formatMoney(this.currentVariant.compare_at_price, KROWN.settings.shop_money_format);
				this.priceCompare.style.display = '';
			} else {
				this.priceCompare.style.display = 'none';
			}

			if ( this.currentVariant.unit_price_measurement ) {
				this.priceUnit.innerHTML = `
					${KROWN.helpers.formatMoney(this.currentVariant.unit_price, KROWN.settings.shop_money_format)} / 
					${( this.currentVariant.unit_price_measurement.reference_value != 1 ? this.currentVariant.unit_price_measurement.reference_value + ' ' : '' )}
					${this.currentVariant.unit_price_measurement.reference_unit}
				`;
			} else {
				this.priceUnit.innerHTML = '';
			}
            // Extra logic to retain "deposit" but remove USD if this is a deposit valid product. 
            if (window.webfx_is_deposit_product) { // set in instock_tab.liquid
                this.priceOriginal.innerText = this.priceOriginal.innerText.replace('USD', 'Deposit');
       //          console.log(this.price);
       //          console.log(this.priceOriginal);
    			// console.log(this.priceCompare);
    			// console.log(this.priceUnit);
            }
          
		}
	
	}

	updateStock(){
		if (!this.currentVariant) {
			if ( this.productStock )
			this.productStock.innerHTML = '';
		} else {
			if ( this.productStock && this.productStockData ) {
				let currentVariant = false;
				for ( const variant of this.productStockData ) {
					if ( variant.id == this.currentVariant.id ) {
						currentVariant = variant;
						break;
					}
				}
				this.productStock.innerHTML = '';
				if ( currentVariant ) {
					if ( currentVariant.quantity <= 0 ) {
						if ( currentVariant.inventory == 'continue' ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_preorder;
						} else if ( currentVariant.inventory == 'deny' ) {
							this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
						}
					} else if ( currentVariant.quantity == '1' ) {
						this.productStock.innerHTML = KROWN.settings.locales.products_one_product;
					} else if ( currentVariant.quantity <= 5 ) {
						this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace('{{ count }}', currentVariant.quantity);
					} else if ( currentVariant.unavailable ) {
						this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
					} else if ( currentVariant.quantity > 5 && this.productStock.dataset.type == "always" ) {
						this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace('{{ count }}', currentVariant.quantity);
					}
				}
			}
		}
	}

	updateDetails(){
		if ( this.productSKU ) {
			if ( this.currentVariant.sku ) {
				this.productSKU.textContent = KROWN.settings.locales.product_sku + this.currentVariant.sku;
			} else {
				this.productSKU.textContent = '';
			}
		}
		if ( this.productBARCODE ) {
 			if ( this.currentVariant.barcode ) {
				this.productBARCODE.textContent = KROWN.settings.locales.product_barcode + this.currentVariant.barcode;
			} else {
				this.productBARCODE.textContent = '';
			}
		}
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	updateUnavailableVariants(){

		if ( this.dataset.hideVariants == 'true' ) {

	 		let options1 = {},
					options2 = {},
					options3 = {},

					option1Selected = null,
					option2Selected = null;

			if ( this.dataset.variants > 1 ) {
				option1Selected = this._getSelectedOption(0);
				this._resetDisabledOption(1);
			}
			if ( this.dataset.variants > 2 ) {
				option2Selected = this._getSelectedOption(1);
				this._resetDisabledOption(2);
			}

			this.getVariantData().forEach((el) => {

				 if ( this.dataset.variants > 0 ) {
					if ( ! options1[el.option1] ) {
						options1[el.option1] = [];
					}
					options1[el.option1].push(String(el.available));
				}
				if ( this.dataset.variants > 1 ) {
					if ( ! options2[el.option2] ) {
						options2[el.option2] = [];
					}
					options2[el.option2].push(String(el.available));
				}
				if ( this.dataset.variants == 2 ) {
					if ( el.option1 == option1Selected && ! el.available ) {
						this._setDisabledOption(1, el.option2);
					}
				}
				if ( this.dataset.variants > 2 ) {
					if ( ! options3[el.option3] ) {
						options3[el.option3] = [];
					}
					options3[el.option3].push(String(el.available));
					if ( el.option2 == option2Selected && el.option1 == option1Selected && ! el.available ) {
						this._setDisabledOption(2, el.option3);
					}
				}

			});

			// temporary
			return;

			if ( this.dataset.variants > 0 ) {
				Object.keys(options1).forEach((key)=>{
					if ( ! options1[key].includes('true') ){
						this.querySelectorAll('.product-variant')[0].querySelector(`.product-variant-value[value="${key}"]`).setAttribute('disabled', 'disabled');
						this.querySelectorAll('.product-variant')[0].querySelector(`.product-variant-value[value="${key}"]`).parentNode.classList.add('d-none');
					}
				});
			}
			if ( this.dataset.variants > 1 ) {
				Object.keys(options2).forEach((key)=>{
					if ( ! options2[key].includes('true') ){
						this.querySelectorAll('.product-variant')[1].querySelector(`.product-variant-value[value="${key}"]`).setAttribute('disabled', 'disabled');
						this.querySelectorAll('.product-variant')[1].querySelector(`.product-variant-value[value="${key}"]`).parentNode.classList.add('d-none');
					}
				});
			}
			if ( this.dataset.variants > 2 ) {
				Object.keys(options3).forEach((key)=>{
					if ( ! options3[key].includes('true') ){
						this.querySelectorAll('.product-variant')[2].querySelector(`.product-variant-value[value="${key}"]`).setAttribute('disabled', 'disabled');
						this.querySelectorAll('.product-variant')[2].querySelector(`.product-variant-value[value="${key}"]`).parentNode.classList.add('d-none');
					}
				});
				Object.keys(options2).forEach((key)=>{
					if ( ! options2[key].includes('true') ){
						if ( option2Selected == key ) {
							this.querySelectorAll('.product-variant')[2].querySelector('.product-variant-value').setAttribute('disabled', 'disabled');
							this.querySelectorAll('.product-variant')[2].querySelector('.product-variant-value').parentNode.classList.add('d-none');
						}
					}
				});
			}

		}
	}

	_getSelectedOption(i){
		if ( this.dataset.type == 'select' ) {
			return this.querySelectorAll('.product-variant')[i].querySelector('.product-variant-container').value;
		} else if ( this.dataset.type == 'radio' ) {
			let selectedOption = null;
			this.querySelectorAll('.product-variant')[i].querySelectorAll('.product-variant__input').forEach(elm=>{ if (elm.checked) selectedOption = elm.value });
			return selectedOption;
		}
	}

	_resetDisabledOption(i){
		this.querySelectorAll('.product-variant')[i].querySelectorAll('.product-variant-value').forEach((elm)=>{
			elm.removeAttribute('disabled');
		})
	}

	_setDisabledOption(i,option){

		// temporary
		return 

		this.querySelectorAll('.product-variant')[i].querySelector(`.product-variant-value[value="${option}"]`).setAttribute('disabled', 'disabled');
		this.querySelectorAll('.product-variant')[i].querySelector(`.product-variant-value[value="${option}"]`).parentNode.classList.add('d-none');
	}

	updateURL(){
		if (!this.currentVariant) return;
		window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateVariantInput() {
		if (!this.currentVariant) return;
		const productForms = document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`);
		
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});
	}

	getVariantData(){
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

}

customElements.define('product-variants', ProductVariants);

/* ---
	Product Form
--- */

// class ProductForm extends HTMLElement {
// 	constructor() {
// 		super();   
// 		this.init();
// 	}

// 	init(){
// 		if ( this.hasAttribute('data-ajax-cart') && ! document.body.classList.contains('template-cart') ) {
// 			this.form = this.querySelector('form');
// 			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
// 			this.ADD_TO_CART = new Event('add-to-cart');
// 		}

// 		this.nodePriceDisclaimer = document.querySelector('.js-price-disclaimer')
// 		this.nodeAddToCartBtn = document.querySelector('.js-add-to-cart-btn')
// 		this.nodeAddToCartSpeedbump = document.querySelector('.js-add-to-cart-speedbump')
// 		this.nodeAddToCartSpeedbumpText = document.querySelector('.js-add-to-cart-speedbump-text')
// 		this.nodeAddToCartSpeedbumpCancelBtn = document.querySelector('.js-add-to-cart-speedbump-cancel')
		
// 		this.productMetadata = window?.webfx?.productMetadata || {}
// 		this.variantMetadata = window?.webfx?.variantMetadata || {}

// 		this.bind()
// 	}

// 	bind() {
// 		this.nodeAddToCartBtn.addEventListener( 'click', this.maybeDisplaySpeedBump.bind( this ) )
// 		this.nodeAddToCartSpeedbumpCancelBtn.addEventListener( 'click', this.hideSpeedbump.bind( this ) )

// 		document.addEventListener( 'rf:product:variantChange', this.handleVariantChange.bind( this ) )
// 	}

// 	handleVariantChange( e ) {
// 		const { activeVariant: { id } } = e.detail

// 		const variantMetadata = this.variantMetadata[ id ]

// 		if( !variantMetadata ) {
// 			this.nodePriceDisclaimer.innerHTML = ''
// 			this.nodeAddToCartBtn.classList.remove( 'js-add-to-cart-init-speedbump' )
// 			this.nodeAddToCartSpeedbumpText.innerHTML = ''
// 		} else {
// 			this.nodePriceDisclaimer.innerHTML = variantMetadata.textDepositAbovePrice
// 			this.nodeAddToCartSpeedbumpText.innerHTML = variantMetadata.textDepositSpeedbump
// 			this.nodeAddToCartBtn.classList.toggle( 'js-add-to-cart-init-speedbump', variantMetadata.textDepositSpeedbump )
// 		}
// 	}

// 	maybeDisplaySpeedBump( e ) {
// 		if( this.nodeAddToCartBtn.classList.contains( 'js-add-to-cart-init-speedbump' ) ) {
// 			e.preventDefault()
			
// 			this.showSpeedBump()
// 		}
// 	}

// 	showSpeedBump() {
// 		document.body.classList.add( 'is-fixed' )
// 		this.nodeAddToCartSpeedbump.classList.add( 'is-visible' )
// 	}

// 	hideSpeedbump() {
// 		this.nodeAddToCartSpeedbump.classList.remove( 'is-visible' )
// 		document.body.classList.remove( 'is-fixed' )
// 	}	

// 	onSubmitHandler(e) {
// 		e.preventDefault();

// 		const self = this
// 		const submitButton = document.querySelector('.buttons-holder button[type=submit]');

// 		submitButton.classList.add('working');

// 		const body = serializeForm(this.form);
// 		let alert = '';

// 		fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
// 			body,
// 			headers: {
// 				'Content-Type': 'application/x-www-form-urlencoded',
// 				'X-Requested-With': 'XMLHttpRequest'
// 			},
// 			method: 'POST'
// 		})
// 			.then(response => response.json())
// 			.then(response => {
// 				if ( response.status == 422 ) {
// 					// wrong stock logic alert
// 					alert = document.createElement('span');
// 					alert.className = 'alert body-text-sm alert--error';
// 					alert.innerHTML = response.description
// 					return fetch('?section_id=cart-helper');
// 				} else {
// 					return fetch('?section_id=cart-helper');
// 				}
// 			})
// 			.then(response => response.text())
// 			.then(text => {

// 				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
// 				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
// 				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

// 				const cartItems = document.getElementById('AjaxCartForm');
// 				cartItems.innerHTML = cartFormInnerHTML;
// 				cartItems.ajaxifyCartItems();

// 				if ( alert != '' ) {
// 					document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
// 				}

// 				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
// 				window.preloadImages(cartItems);

// 				document.querySelector('[data-header-cart-count]').textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
// 				this.dispatchEvent(this.ADD_TO_CART);

// 				self.hideSpeedbump()
// 			})
// 			.catch(e => {
// 				console.log(e);
// 			})
// 			.finally(() => {
// 				submitButton.classList.remove('working');
// 			});
// 	}
// }

// customElements.define('product-form', ProductForm);


/* ---
	Pickup availability
--- */

class PickupAvailability extends HTMLElement {

	constructor(){
		super();
		this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
		this.onClickRefreshList = this.onClickRefreshList.bind(this);
		if(!this.hasAttribute('available')) return;
		this.fetchAvailability(this.dataset.variantId);
	}

	fetchAvailability(variantId) {

		const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

		fetch(variantSectionUrl)
			.then(response => response.text())
			.then(text => {
				const sectionInnerHTML = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('.shopify-section');
				this.renderPreview(sectionInnerHTML);
			})
			.catch(e => {
				console.log(e);
				if ( this.querySelector('button') ) {
					this.querySelector('button').removeEventListener('click', this.onClickRefreshList);
				}
				this.renderError();
			});

	}

	onClickRefreshList() {
		this.fetchAvailability(this.dataset.variantId);
	}

	renderError() {
		this.innerHTML = '';
		this.appendChild(this.errorHtml);
		this.querySelector('button').addEventListener('click', this.onClickRefreshList);
	}

	renderPreview(sectionInnerHTML){
		
		const drawer = document.getElementById('PickupAvailabilityDrawer');
		if (drawer) drawer.remove();

		if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
			this.innerHTML = "";
			this.removeAttribute('available');
			return;
		}

		this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
		this.setAttribute('available', '');
		document.body.appendChild(sectionInnerHTML.querySelector('#PickupAvailabilityDrawer'));

		this.querySelector('button').addEventListener('click', (evt) => {
			document.getElementById('PickupAvailabilityDrawer').show(evt.target);
		});
		this.querySelector('button').addEventListener('keyup', e=>{
			if ( e.keyCode == window.KEYCODES.RETURN ) {
				document.getElementById('PickupAvailabilityDrawer').querySelector('[data-close]').focus();
			}
		})

	}

}
customElements.define('pickup-availability', PickupAvailability);

/* ---
	Product Image Zoom
--- */

class ProductImageZoom extends HTMLElement {

	constructor(){

		super();

		if ( ! document.getElementById('zoom') ) {
			this.zoom = document.createElement('div');
			this.zoom.id = 'zoom';
			this.zoom.innerHTML = `
				<img />
				<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
				<div class="zoom__overlay"></div>
			`;
			document.body.append(this.zoom);
			this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
		} else {
			this.zoom = document.getElementById('zoom');
		}

		this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
		this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

		this.addEventListener('click', (e)=>{
			this.zoom.classList.add('opened');
			this.image = this.zoom.querySelector('img');
			this.image.src = this.getAttribute('data-image');
			if ( this.image.naturalWidth > 0 ) {
				this._productZoomMount();
			} else {
				this.image.addEventListener('load', this._productZoomMount.bind(this));
			}
		});

	}

	onMouseMoveHandler(e){
		window.clientX = e.clientX;
		window.clientY = e.clientY;
		const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
		const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
		this.image.style.left = x + 'px';
		this.image.style.top = y + 'px';
	}

	onResizeHandler(){

		const rf = window.innerWidth > 768 ? 1 : 2;

		if ( this.image.classList.contains('portrait') ) {
			this.image.style.width = ( window.innerWidth*rf ) + 'px';
			this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
		} else {

			this.image.style.height = ( window.innerHeight*rf ) + 'px';
			this.image.style.width = ( window.innerHeight*rf * this.image.dataset.ratio ) + 'px';

			if ( this.image.offsetWidth < window.innerWidth ) {
				this.image.style.width = ( window.innerWidth*rf ) + 'px';
				this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
			}

		}

		const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
		const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;

	}

	_productZoomMount(image) {

		this.image.style.left = 0;
		this.image.style.top = 0;

		window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});

		this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
		window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
		this.onResizeHandler();

		setTimeout(()=>{
			if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
				this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
				this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
			}
			this.zoom.classList.add('loaded');
		}, 50);

	}

	_productZoomUnmount() {

		this.zoom.classList.remove('opened');

		setTimeout(()=>{
			window.removeEventListener('resize', this.onResizeHandlerBinded);
			window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
			const image = document.querySelector('#zoom img');
			image.src = '';
			image.className = '';
			image.style = '';
			this.zoom.classList.remove('loaded');
		}, 300);

	}

}

customElements.define('product-image-zoom', ProductImageZoom);
class SearchForm extends HTMLElement {

	constructor() {

		super();	
		this.cachedResults = {};
		this.input = this.querySelector('[data-search-input]');
		this.predictiveSearchResults = this.querySelector('[data-search-results]');
		this.results = [];
		this.preloader = false;

		if ( KROWN.settings.predictive_search_enabled != "false" ) {

			let inputValue = this.input.value;
			this.input.addEventListener('keyup', debounce(e=>{
				if ( this.input.value != inputValue ) {
					inputValue = this.input.value;
					this.getSearchResults(this.input.value.trim());
				} else if ( this.input.value == '' ) {
					this.clearSearchResults();
				}
			},150));

			this.input.addEventListener('keydown', e=>{
				if ( this.a11yIndex != -1 ) {
					if (
						e.keyCode === window.KEYCODES.UP ||
						e.keyCode === window.KEYCODES.DOWN ||
						e.keyCode === window.KEYCODES.RETURN
					) {
						e.preventDefault();
					}
				}
			});

			this.input.addEventListener('keyup', e=>{
				if (e.keyCode === window.KEYCODES.UP) {
					this.navigateThrough('UP');
					return true;
				}

				if (e.keyCode === window.KEYCODES.DOWN) {
					this.navigateThrough('DOWN');
					return true;
				}

				if (e.keyCode === window.KEYCODES.RETURN) {
					if ( this.a11yIndex != -1 ) {
						let href
						let target = this.results[this.a11yIndex]

						if( 'A' !== target.tagName ) {
							target = target.querySelector('a')
						}

						if( target ) {
							href = target.getAttribute('href')
						}

						if( href ) {
							document.location.href = href
						}
					}
				}
			})

		}

	}

	getSearchResults(query="") {

		this.preloadSearchResults();

		const queryKey = query.replace(" ", "-").toLowerCase();
		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey]);
			return;
		}

		this.a11yIndex = -1;

		fetch(`${KROWN.settings.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=${this.dataset.resourceType}&resources[limit]=4&section_id=predictive-search&resources[options][unavailable_products]=show`)
			.then(response=>{
				if (!response.ok) {
					var error = new Error(response.status);
					this.clearSearchResults();
					throw error;
				}
				return response.text();
			})
			.then(text=>{
				const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.cachedResults[queryKey] = results;
				this.renderSearchResults(results);
			})	
			.catch((e) => {
				throw e;
			}); 

	}

	clearSearchResults(){
		this.predictiveSearchResults.innerHTML = '';
		this.preloader = false;
		this.results = [];
	}

	preloadSearchResults(){
		if ( ! this.preloader ) {
			this.preloader = true;
			this.predictiveSearchResults.innerHTML = KROWN.settings.predictive_search_placeholder;
		}
	}

	renderSearchResults(results){
		this.predictiveSearchResults.innerHTML = results;
		this.preloader = false;
		this.results = this.predictiveSearchResults.querySelectorAll('.search-item, .sidebar__search-link');
		window.preloadImages(this.predictiveSearchResults);
	}

	navigateThrough(direction){

		if ( this.a11yIndex == -1 ) {
			this.a11yIndex = 0;
		} else {
			this.results[this.a11yIndex].classList.remove('active');
			if ( direction == 'UP' ) {
				if ( this.a11yIndex - 1 >= -1 ) {
					this.a11yIndex--;
				} 
			} else if ( direction == 'DOWN' ) {
				if ( this.a11yIndex + 1 < this.results.length ) {
					this.a11yIndex++;
				} 
			}
		}

		if ( this.a11yIndex >= 0 ) {
			this.results[this.a11yIndex].classList.add('active');
			document.getElementById('site-search-sidebar').scrollTop = this.results[this.a11yIndex].offsetTop - 200;
		} else {
			document.getElementById('site-search-sidebar').scrollTop = 0;
		}

	}

}
customElements.define('search-form', SearchForm);



class CSSSlider extends HTMLElement {

	constructor(){

		super();

		this._touchScreen = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
		const ua = navigator.userAgent.toLowerCase();
		this._ios15 = this._touchScreen && ua.includes('applewebkit') && ( ua.includes('os 15_') || ua.includes('version/15') );

		// create option object, from defaults
		this.o = {
			...{
				selector: '.css-slide', 
				snapping: true, 
						groupCells: false,
				autoHeight: false, 
				navigation: true,
				navigationDOM: `<span class="css-slider-button css-slider-prev" style="display:none">←</span>
					<span class="css-slider-button css-slider-next" style="display:none">→</span>`,
				thumbnails: true,
				thumbnailsDOM: `<div class="css-slider-dot-navigation" style="display:none"></div>`,
				indexNav: false,
				indexNavDOM: `<div class="css-slider-index-navigation"><span class="css-slider-current">1</span> / <span class="css-slider-total">1</span></div>`,
				watchCSS: false,
				undisplay: false,
				listenScroll: false,
			}, ...JSON.parse(this.dataset.options)
		};

		if( undefined !== this.dataset.mediaElements ) {
			this.mediaElements = JSON.parse( this.dataset.mediaElements )

			const mediaElementsArray = Array.from( this.mediaElements )

			if( mediaElementsArray.some( mediaElement => 'youtube' == mediaElement.host ) ) {
				this.setupYoutube()
			}

			if( mediaElementsArray.some( mediaElement => 'vimeo' == mediaElement.host ) ) {
				this.setupVimeo()
			}			
		}

		// init slider or watch for css
		if ( ! this.o.watchCSS ) {
			this.initSlider();
		} else {
			this.RESIZE_WATCHER = debounce(()=>{
				const afterContent = window.getComputedStyle(this,':after').content;
				if ( afterContent.includes('css-slide') && !this.sliderEnabled ) {
					this.initSlider();
				} else if ( !afterContent.includes('css-slide') && this.sliderEnabled )  { 
					this.destroySlider();
				}
			}, 100);
			window.addEventListener('resize', this.RESIZE_WATCHER);
			this.RESIZE_WATCHER();
		}
	}


	setupYoutube() {
		if( 'object' === typeof YT ) {
			this.initYoutubeVideos()
		} else {
			const tag = document.createElement( 'script' )
			tag.src = 'https://www.youtube.com/player_api';
			document.head.appendChild( tag )

			window.onYouTubePlayerAPIReady = this.initYoutubeVideos.bind( this )
		}
	}


	setupVimeo() {
		if( 'object' !== typeof Vimeo ) {
			const tag = document.createElement( 'script' )
			tag.src = 'https://player.vimeo.com/api/player.js';
			document.head.appendChild( tag )
		}

		this.vimeoVideos = new Map
	}


	initYoutubeVideos() {
		this.youtubeVideos = new Map

		this.querySelectorAll('.product-gallery-item--youtube').forEach( slide => {
			const videoId = slide.dataset.videoId
			const container = slide.querySelector('.video-player--youtube')

			if( container ) {
				const player = new YT.Player( `youtube-video-player-${videoId}`, {
					videoId: videoId,
				})

				this.youtubeVideos.set( videoId, player )
			}
		})
	}


	updateYoutubePlayStates() {
		if( undefined === this.youtubeVideos ) {
			return
		}

		Array
			.from( this.indexedItems )
			.filter( slide => 'external_video-youtube' === slide.dataset.productMediaType )
			.forEach( slide => {
				const youtubeId = slide.dataset.videoId

				if( this.youtubeVideos.has( youtubeId ) ) {
					const player = this.youtubeVideos.get( youtubeId )

					if( slide.classList.contains( 'css-slide-active' ) ) {
						if( 'function' === typeof player.playVideo ) {
							player.playVideo()
						}
					} else {
						if( 'function' === typeof player.pauseVideo ) {
							player.pauseVideo()
						}
					} 
				}
			})
	}


	updateVimeoPlayStates() {
		if( undefined === this.vimeoVideos ) {
			return
		}

		Array
			.from( this.indexedItems )
			.filter( slide => 'external_video-vimeo' === slide.dataset.productMediaType )
			.forEach( slide => {
				const vimeoId = slide.dataset.videoId

				if( !this.vimeoVideos.has( vimeoId ) ) {
					const player = new Vimeo.Player( slide.querySelector('.js-vimeo'), {
						id: vimeoId
					})

					this.vimeoVideos.set( vimeoId, player )
				}

				const player = this.vimeoVideos.get( vimeoId )
				
				if( slide.classList.contains( 'css-slide-active' ) ) {
					player.getPaused().then( () => {
						setTimeout( () => { 
							player.play()
						}, 1000 )
					})
				} else {
					player.pause()
				} 
			})
	}	


	destroySlider(){
		this.innerHTML = `${this.originalHTML}`;
		this.classList.remove('enabled');
		this.sliderEnabled = false;
		window.removeEventListener('resize', this.RESIZE_EVENT);
		window.removeEventListener('scroll', this.SCROLL_EVENT);
		window.removeEventListener('scroll', this.SCROLL_EVENT_ANIMATION);
		window.preloadImages(this);
	}

	initSlider(){

		// create custom events

		this._readyEvent = new CustomEvent('ready');
		this._changeEvent = new CustomEvent('change');
		this._scrollEvent = new CustomEvent('scroll');
		this._navEvent = new CustomEvent('navigation');
		this._pointerDownEvent = new CustomEvent('pointerDown');
		this._pointerUpEvent = new CustomEvent('pointerUp');

		// create slider structure

		this.classList.add('css-slider');
		this.originalHTML = this.innerHTML;
		this.innerHTML = `<div class="css-slider-viewport">
			<div class="css-slider-holder">
				<div class="css-slider-container">
					${this.originalHTML}
				</div>
			</div>
		</div>`;

		window.preloadImages(this);
		
		// add css-slide to children, if it's not set

		if ( this.o.undisplay ) {
			this.querySelectorAll(`${this.o.selector}`).forEach((elm)=>{
				elm.style.display = 'block';
			})
		}

		if ( this.o.selector != '.css-slide' ) {
			this.querySelectorAll(`${this.o.selector}`).forEach((elm)=>{
				elm.classList.add('css-slide');
			})
		}

		// setup variables

		this.element = this.querySelector('.css-slider-holder');
		if ( this.o.groupCells ) {
			this.element.scrollLeft = 0;
		}

		this.items = this.querySelectorAll(`${this.o.selector}`);
		this.indexedItems = [];
		this.index = 0;
		this.length = this.items.length;
		this.windowWidth = window.innerWidth;
		
		this.viewport = this.querySelector('.css-slider-viewport');
		if ( this.o.autoHeight ) {
			this.viewport.classList.add('auto-height');
		}

		// append navigation

		if ( this.o.navigation || this.o.thumbnails || this.indexNav ) {

			let container = document.createElement('div');
			container.classList.add('css-slider-navigation-container');
			container.innerHTML = `
				${(this.o.navigation ? this.o.navigationDOM : '')}
				${(this.o.thumbnails ? this.o.thumbnailsDOM : '')}
				${(this.o.indexNav ? this.o.indexNavDOM : '')}`;

			if ( this.o.navigation ) {
				this.prevEl = container.querySelector('.css-slider-prev');
				this.prevEl.addEventListener('click', e=>{
					this.changeSlide('prev');
					this.dispatchEvent(this._navEvent);
				});
				this.nextEl = container.querySelector('.css-slider-next');
				this.nextEl.addEventListener('click', e=>{
					this.changeSlide('next');
					this.dispatchEvent(this._navEvent);
				});
			}

			if ( this.o.thumbnails ) {
				this.thumbnailsEl = container.querySelector('.css-slider-dot-navigation'); 
			}

			if ( this.o.indexNav ) {
				this.indexEl = container.querySelector('.css-slider-current');
				this.lengthEl = container.querySelector('.css-slider-total'); 
			}

			this.append(container);

		}

		if ( this.length > 1 ) {

			// observer for slides

			this.RESIZE_EVENT = debounce(()=>{
				if ( this.windowWidth != window.innerWidth && this.o.groupCells) {
					this.resetSlider();
				}
				if ( ! this.o.groupCells ) {
					this.checkSlide();
				}
				this.windowWidth = window.innerWidth;
			}, 100);
			window.addEventListener('resize', this.RESIZE_EVENT);
			this.resetSlider(true);    

			// dispatching scroll event, mostly for extra animations
			if ( this.o.listenScroll ) {
				this.SCROLL_EVENT_ANIMATIONS = (()=>{
					let slidesWidth = -this.querySelector('.css-slider-container').offsetWidth;
					this.items.forEach(elm=>{slidesWidth += elm.offsetWidth});
					this.progress = this.element.scrollLeft / slidesWidth;
					this.dispatchEvent(this._scrollEvent);
				});
				this.element.addEventListener('scroll', this.SCROLL_EVENT_ANIMATIONS, {passive:true});
			}

			this.SCROLL_EVENT = debounce(()=>{
				// checking selected index
				if ( ! this._sliderBlockScroll ) {
					const scrollItems = this.indexedItems.entries();
					const scrollArray = Array.from(scrollItems, elm => Math.abs(elm[1].offsetLeft-this.element.scrollLeft));
					const scrollDistance = Math.min(...scrollArray);
					const scrollIndex = scrollArray.indexOf(scrollDistance);
					/*if ( this.indexedItems[this.length-2].offsetLeft-this.element.scrollLeft < 0 ) {
						this.index = this.length - 1;
						this.checkSlide();
						this.dispatchEvent(this._changeEvent);
					} else */if ( scrollIndex != this.index ) {
						this.index = scrollIndex;
						this.checkSlide();
						this.dispatchEvent(this._changeEvent);
					}

				}
			}, 10);

			// mouse fallback for non-touch devices

			this.element.addEventListener('scroll', this.SCROLL_EVENT, {passive:true});

			if ( ! this._touchScreen && ! this.element.classList.contains('css-slider--singular') ) {
				this.element.addEventListener('mousedown', e=>{
					if ( ! this.element.classList.contains('css-slider--disable-dragging') ) {
						this.mouseX = e.screenX;
						this.element.classList.add('can-drag');
						this.element.classList.add('mouse-down');
					}
				});
				this.element.addEventListener('mouseup', e=>{
					this.element.classList.remove('mouse-down');
					this.element.classList.remove('can-drag');
					this.element.classList.remove('pointer-events-off');
				});

				this.element.addEventListener('mouseleave', e=>{
					this.element.classList.remove('mouse-down');
					this.element.classList.remove('can-drag');
					this.element.classList.remove('pointer-events-off');
				});

				this.element.addEventListener('mousemove', e=>{
					if ( this.element.classList.contains('can-drag') ) {
						this.element.classList.add('pointer-events-off');
						let direction = this.mouseX - e.screenX;
						if ( Math.abs(direction) > 1 ) {
							if ( direction > 0 ) {
								this.changeSlide('next');
								this.element.classList.remove('can-drag');
							} else if ( direction < 0 ) {
								this.changeSlide('prev');
								this.element.classList.remove('can-drag');
							}
						}
					}
				});

			}

			// helper for browser that don't support smooth scrolling

			if ( ! ( "scrollBehavior" in document.documentElement.style ) && ! this._touchScreen ) {
				this.element.classList.add('force-disable-snapping');
			}

		}

		// dispatch ready event

		this.classList.add('enabled');
		this.sliderEnabled = true;
		this.dispatchEvent(this._readyEvent);

	}

	changeSlide(direction, behavior='smooth'){

		// function that changes the slide, either by word (next/prev) or index

		if ( direction == 'next' ) {
			this.index++;
			// if ( this.index+1 < this.length ) {
			// }
		} else if ( direction == 'prev') {
			this.index--;
			// if ( this.index-1 >= 0 ) {
			// }
		} else if ( parseInt(direction) >= 0 ) {
			this.index = parseInt(direction);
		}

		this._sliderBlockScroll = true;
		if ( this._ios15 ) {
			this.element.classList.add('force-disable-snapping');
		}
		setTimeout(()=>{
			this._sliderBlockScroll = false;
			if ( this._ios15 ) {
				this.element.classList.remove('force-disable-snapping');
			}
		}, 500);

		if( this.index >= this.length ) {
			this.index = 0 
		} else if( this.index < 0 ) {
			this.index = this.length - 1
		}
		
		this.checkSlide();

		this.updateYoutubePlayStates()
		this.updateVimeoPlayStates()

		this.element.scrollTo({
			top: 0,
			left: this.indexedItems[this.index].offsetLeft - parseInt(getComputedStyle(this.indexedItems[0]).marginLeft),
			behavior: behavior
		});
		this.dispatchEvent(this._changeEvent);

	}

	checkSlide(){  
		
		// checks slide after index change and updates navigation / viewport

		if ( this.o.navigation ) {
			this.prevEl.classList.remove('disabled');
			this.nextEl.classList.remove('disabled');
			if ( this.index == 0 ) {
				// this.prevEl.classList.add('disabled');
			}
			if ( this.index == this.length - 1 ) {
				// this.nextEl.classList.add('disabled');
			}
		}

		if ( this.o.thumbnails && this.thumbnails ) {
			this.thumbnails.forEach(elm=>{elm.classList.remove('active')});
			this.thumbnails[this.index].classList.add('active');
		}

		if ( this.o.indexNav ) {
			this.indexEl.textContent = this.index+1;
		}
		
		if ( this.o.autoHeight ) {
			this.viewport.style.height = this.indexedItems[this.index].offsetHeight + 'px';
		} 
		
		this.indexedItems.forEach((elm,i)=>{
			if ( i == this.index ) {
				elm.classList.add('css-slide-active');
			} else {
				elm.classList.remove('css-slide-active');
			}
		});

	}

	afterAppend(){
		this.items = this.querySelectorAll(`${this.o.selector}`);
	}

	resetSlider(nojump=false,resetIndex=true){

		let slidesWidth = 0,
				slidesPerPage = 0,
				page = 0,
				pages = 0,
				totalWidth = this.querySelector('.css-slider-container').offsetWidth,// - 20,
				hideNavigation = false;

		// reset entire slider

		this.indexedItems = [];
		this.element.classList.add('disable-snapping');

		// find out how many pages (slides there are now)

		this.items.forEach((elm, i)=>{
			elm.classList.remove('css-slide--snap');
			slidesWidth += elm.offsetWidth;
			if ( slidesWidth > totalWidth && slidesPerPage == 0 ) {
				slidesPerPage = i;
			}
		});

		if ( slidesPerPage == 0 ) {
			slidesPerPage = this.items.length;
			hideNavigation = true;
		}
		// set each slide for observer

		this.items.forEach((elm, i) => {
			if ( i % slidesPerPage == 0  ) {
				elm.classList.add('css-slide--snap');
				elm.setAttribute('data-index', page++);
			}
		});

		this.indexedItems = this.querySelectorAll('.css-slide--snap');
		if ( resetIndex ) {
			this.index = 0;
		}
		this.length = Math.ceil(this.items.length / slidesPerPage);

		// recreate navigation

		if ( this.o.thumbnails ) {
			this.thumbnailsEl.innerHTML = '';
			for ( let i = 0; i < this.length; i++ ) {
				let dot = document.createElement('span');
				dot.classList.add('css-slider-dot');
				dot.dataset.index = i;
				this.thumbnailsEl.appendChild(dot);
				dot.addEventListener('click', (e)=>{
					this.changeSlide(e.target.dataset.index);
				});
			}
			this.thumbnails = this.thumbnailsEl.querySelectorAll('.css-slider-dot');
		}

		if ( this.o.indexNav ) {
			this.indexEl.textContent = this.index+1;
			this.lengthEl.textContent = this.length;
		}

		// hide navigation if only one slide

		if ( hideNavigation ) {
			this.element.classList.add('css-slider--no-drag');
			if ( this.o.navigation ) {
				this.prevEl.style.display = 'none';
				this.nextEl.style.display = 'none';
			}
			if ( this.o.thumbnails ) {
				this.thumbnailsEl.style.display = 'none';
			}
		} else {
			this.element.classList.remove('css-slider--no-drag');
			if ( this.o.navigation ) {
				this.prevEl.style.display = 'block';
				this.nextEl.style.display = 'block';
			}
			if ( this.o.thumbnails ) {
				this.thumbnailsEl.style.display = 'block';
			}
		}

		this.checkSlide();

		if ( ! nojump ) {
			this.element.scrollTo({
				top: 0,
				left: 0,
				behavior: 'auto'
			})
		}
		this.element.classList.remove('disable-snapping');

	}

}
customElements.define('css-slider', CSSSlider);

document.addEventListener('shopify:section:load', (e)=>{
	if ( e.target.classList.contains('mount-css-slider') && e.target.querySelector('css-slider') ) {
		e.target.querySelectorAll('css-slider').forEach(slider=>{if(slider.enabled)slider.resetSlider()});
	}
});
class ToggleTab extends HTMLElement {

	constructor(){

		super();

		this.titleEl = this.querySelector('.toggle__title');
		this.contentEl = this.querySelector('.toggle__content');

		this.titleEl.innerHTML = `${this.titleEl.innerHTML}${KROWN.settings.symbols.toggle_pack}`;

		this.titleEl.addEventListener('click',this.onClickHandler.bind(this));
		this.titleEl.addEventListener('keydown', e=>{
			if ( e.keyCode == window.KEYCODES.RETURN ) {
				this.onClickHandler();
			}
		})

		this.querySelectorAll('.js-featured-finish').forEach( el => {
			el.addEventListener( 'click', e => {
				const swatchId = el.dataset.finishId
	  	  
				if( 'string' === typeof swatchId && swatchId.length ) {
				  const customEvent = new CustomEvent( 'webfx:swatch:click', {
					detail: {
					  swatchId
					}
				  })
	  
				  window.dispatchEvent( customEvent )
				}
			})
		})

	}

	onClickHandler(){
		if ( ! this.titleEl.classList.contains('opened') ) {
			this.titleEl.classList.add('opened');
			this.titleEl.setAttribute('aria-expanded', 'true');
			this.slideDown(this.contentEl, 200);
		} else {
			this.titleEl.classList.remove('opened');
			this.titleEl.setAttribute('aria-expanded', 'false');
			this.slideUp(this.contentEl, 200);
		}
	}

	slideUp(target, duration){
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		setTimeout(()=>{
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}
	slideDown(target, duration) {
		target.style.removeProperty('display');
		var display = window.getComputedStyle(target).display;

		if (display === 'none')
			display = 'block';

		target.style.display = display;
		var height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		setTimeout(()=>{
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}

}
customElements.define('toggle-tab', ToggleTab);

document.addEventListener('shopify:block:select', e=>{
	const block = e.target;
	if ( block.classList.contains('toggle') ) {
		if ( !block.querySelector('.toggle__title').classList.contains('opened') ) {
			block.onClickHandler();
		}
	}
})
document.addEventListener('shopify:block:deselect', e=>{
	const block = e.target;
	if ( block.classList.contains('toggle') ) {
		if ( block.querySelector('.toggle__title').classList.contains('opened') ) {
			block.onClickHandler();
		}
	}
})
class VideoPopup extends HTMLElement {

	constructor(){
		super();
		this.querySelector('.video-popup__link').addEventListener('click',e=>{
			e.preventDefault();

			const blackout = document.createElement('div');
			blackout.classList.add('video-popup__blackout');
			this.append(blackout);
			setTimeout(()=>{
				blackout.style.opacity = '1';
			},10)

			this.classList.add('video-opened');

			if ( this.querySelector('.video-popup__close') ) {
				this.querySelector('.video-popup__close').addEventListener('click', e=>{
					this.querySelectorAll('iframe, video').forEach(elm=>{elm.remove()});
					this.querySelector('.video-popup__blackout').remove();
					this.classList.remove('video-opened');
				})
			}

			setTimeout(()=>{
				pauseAllMedia();

				const template = this.querySelector('template')

				if( template ) {
					this.querySelector('.video-popup__container').appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
					setTimeout(()=>{
						playMedia(this.closest('[data-video]'));
					}, 500);
				}
			},50);

		});

	}

}

customElements.define('video-popup', VideoPopup);

class VideoBackground extends HTMLElement {

	constructor(){

		super();

		const canSrc = 'data:video/mp4;base64,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';
		let canVideoPlaying = false;
		let canVideo = document.createElement('video');
		canVideo.setAttribute('playsinline', 'playsinline');
		canVideo.setAttribute('muted', 'muted');
		canVideo.setAttribute('autoplay', 'autoplay');
		canVideo.setAttribute('loop', 'loop');
		canVideo.setAttribute('controls', 'controls');
		canVideo.setAttribute('width', 20);
		canVideo.setAttribute('height', 20);
		canVideo.onplay = ()=>{canVideoPlaying = true}
		canVideo.setAttribute('src', canSrc);
		canVideo.style.position = 'fixed';
		canVideo.style.top = '-20px';
		canVideo.style.left = '0px';
		canVideo.style.zIndex = '997';
		document.querySelector('body').appendChild(canVideo);

		let playPromise = canVideo.play();
		if ( playPromise !== undefined ) {
			playPromise.then(()=>{
				this.autoPlayCallback(true);
				canVideo.remove();
			})
			.catch((error)=>{
				if ( canVideoPlaying || error.toString().includes('interact with the document') ) {
					this.autoPlayCallback(true);
				} else {
					this.autoPlayCallback(false);
				}
				canVideo.remove();
			})
		}

		window.addEventListener( 'load', () => {
			this.autoplayVideos()
		})
	}

	autoPlayCallback(canAutoPlay){
		if ( canAutoPlay ) {
			const video = this.querySelector('.video-text__background');
			if ( video ) {
				video.innerHTML = `<video autoplay muted loop playsinline><source type="video/mp4" src="${video.dataset.src}"></video>`;
				video.querySelector('video').play();
				setTimeout(()=>{
					video.querySelector('video').style.opacity = '1';
				}, 200);
			}
		} else {
			this.querySelector('.video-text__background .video-text__image').style.display = 'block';
		}
	}


	autoplayVideos() {
		const self = this

		if( 'object' !== typeof Vimeo ) {
			console.warn( 'Vimeo Player is not defined.' )
			return
		}

		document.querySelectorAll('.video-background__video').forEach( video => {

			// only apply to Vimeo videos
			if( ! /player.vimeo.com/.test( video.src ) ) {
				return
			}

			const player = new Vimeo.Player( video )

			player.on( 'play', e => {
				const imgCover = document.getElementById(`video-${video.dataset.vimeoVideoId}`)

				if( !imgCover.classList.contains('is-hidden') ) {
					imgCover.classList.add( 'is-hidden' )
				}
			})

			const observer = new IntersectionObserver( entries => {
				entries.forEach( entry => {
					player.getPaused().then( isPaused => {
						if( entry.isIntersecting ) {
							if( isPaused ) {
								player.play()
							}
						} else {
							if( !isPaused ) {
								player.pause()
							}
						}
					})
				})
			})

			observer.observe( video )
		})
	}

}

customElements.define('video-background', VideoBackground);
KROWN.helpers = {

	formatMoney: function(cents, format){

		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}

		let value = '';
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			thousands = thousands || ',';
			decimal = decimal || '.';

			if (isNaN(number) || number === null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			const parts = number.split('.');
			const dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				'$1' + thousands
			);
			const centsAmount = parts[1] ? decimal + parts[1] : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
			case 'amount_with_apostrophe_separator':
				value = formatWithDelimiters(cents, 2, "'");
				break;
		}

		return formatString.replace(placeholderRegex, value);

	}

}

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

// Returns pseudo content

const getPseudoContent = selector => {
	var element = document.querySelector(selector),
			pseudo = window.getComputedStyle(element, ':after');
	return pseudo.getPropertyValue('content');
}

const pauseAllMedia = () => {
	document.querySelectorAll('.product .js-youtube').forEach(video => {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});
	document.querySelectorAll('.product .js-vimeo').forEach(video => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('.product video').forEach(video => video.pause());
	document.querySelectorAll('.product product-model').forEach(model => {
		if ( model.modelViewerUI ) 
			model.modelViewerUI.pause()
	});
}

const playMedia = (media) => {
	switch ( media.dataset.productMediaType ) {
		case 'video':
			media.querySelector('video').play();
			break;
		case 'external_video-youtube':
			media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
			break;
		case 'external_video-vimeo':
			media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
			break;
	}
}

/*!
 * Serialize all form data into a SearchParams string
 * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */

const serializeForm = form => {
	let arr = [];
	Array.prototype.slice.call(form.elements).forEach(function(field) {
		if (
			!field.name ||
			field.disabled ||
			['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
		)
			return;
		if (field.type === 'select-multiple') {
			Array.prototype.slice.call(field.options).forEach(function(option) {
				if (!option.selected) return;
				arr.push(
					encodeURIComponent(field.name) +
						'=' +
						encodeURIComponent(option.value)
				);
			});
			return;
		}
		if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
			return;
		arr.push(
			encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
		);
	});
	return arr.join('&');
};

// get jsonp

const getJSONP = (url, success) => {

	var ud = '_' + +new Date,
			script = document.createElement('script'),
			head = document.getElementsByTagName('head')[0] 
						 || document.documentElement;

	window[ud] = function(data) {
			head.removeChild(script);
			success && success(data);
	};

	script.src = url.replace('callback=?', 'callback=' + ud);
	head.appendChild(script);

}

const trueTypeOf = obj => {
	return Object.prototype.toString
		.call(obj)
		.slice(8, -1)
		.toLowerCase();
}

const htmlEscape = input => {
	return input
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

const reframe = (target, cName) => {
	let frames = (typeof target === 'string') ? document.querySelectorAll(target) : target
	const c = cName || 'js-reframe'
	if (!('length' in frames)) frames = [frames]
	for (let i = 0; i < frames.length; i += 1) {
		const frame = frames[i]
		// makes sure reframe is not run more than 1x ✔️
		const hasClass = frame.className.split(' ').indexOf(c) !== -1

		if (hasClass || frame.style.width.indexOf('%') > -1) continue

		// get height width attributes
		const h = frame.getAttribute('height') || frame.offsetHeight
		const w = frame.getAttribute('width') || frame.offsetWidth

		// general targeted <element> sizes
		const padding = (h / w) * 100

		// created element <wrapper> of general reframed item
		// => set necessary styles of created element <wrapper>
		const div = document.createElement('div')
		div.className = c
		const divStyles = div.style
		divStyles.position = 'relative'
		divStyles.width = '100%'
		divStyles.paddingTop = `${padding}%`

		// set necessary styles of targeted <element>
		const frameStyle = frame.style
		frameStyle.position = 'absolute'
		frameStyle.width = '100%'
		frameStyle.height = '100%'
		frameStyle.left = '0'
		frameStyle.top = '0'

		// reframe targeted <element>
		frame.parentNode.insertBefore(div, frame)
		frame.parentNode.removeChild(frame)
		div.appendChild(frame)
	}
}

window.KEYCODES = {
	TAB: 9,
	ESC: 27,
	DOWN: 40,
	RIGHT: 39,
	UP: 38,
	LEFT: 37,
	RETURN: 13
};
const slideUp = (target, duration) => {
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	setTimeout(()=>{
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
}
const slideDown = (target, duration) => {
	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;

	if (display === 'none')
		display = 'block';

	target.style.display = display;
	const height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	setTimeout(()=>{
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
}
/* 
	* This is the class for the theme's
		unique main header (navigation)
*/

class MainHeader extends HTMLElement {

	constructor(){
		super();
		this.mount();
	}

	mount(){

		/* -- > DRAWERS < -- */

		// drawer menu connections

		const sidebarMenu = document.getElementById('site-nav--mobile');

		if ( document.getElementById('site-menu-handle') ) {

			document.getElementById('site-menu-handle').addEventListener('click', e=>{
				e.preventDefault();
				document.getElementById('site-menu-handle').setAttribute('aria-expanded', 'true');
				sidebarMenu.show();
			})
			document.getElementById('site-menu-handle').addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					sidebarMenu.querySelector('.site-close-handle').focus();
				}
			})

		}

		// drawer cart connections

		const sidebarCart = document.getElementById('site-cart');

		if ( document.getElementById('site-cart-handle') ) {

			document.getElementById('site-cart-handle').addEventListener('click', e=>{
				e.preventDefault();
				document.getElementById('site-cart-handle').setAttribute('aria-expanded', 'true');
				sidebarCart.show();
			})
			document.getElementById('site-cart-handle').addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					sidebarCart.querySelector('.site-close-handle').focus();
				}
			})

		}

		// drawer search connections

		const sidebarSearch = document.getElementById('site-search');

		if ( document.getElementById('site-search-handle') ) {

			document.getElementById('site-search-handle').addEventListener('click', e=>{
				e.preventDefault();
				document.getElementById('site-search-handle').setAttribute('aria-expanded', 'true');
				sidebarSearch.show();
				setTimeout(()=>{
					sidebarSearch.querySelector('[data-search-input]').focus();
				}, 10);
			})

		}

		// closing drawers

		document.addEventListener('keydown', e=>{
			if ( e.keyCode == window.KEYCODES.ESC ) {
				document.querySelector('sidebar-drawer.active')?.hide();
			}
		});

		document.getElementById('site-overlay').addEventListener('click', ()=>{
			document.querySelector('sidebar-drawer.active')?.hide();
		});

		// resizing drawers

		this.RESIZE_SidebarHelper = debounce(()=>{
						if ( document.querySelector('sidebar-drawer.active') ) {
				document.querySelector('sidebar-drawer.active').style.height = window.innerHeight + 'px';
			}
		}, 200);

		window.addEventListener('resize', this.RESIZE_SidebarHelper);
		this.RESIZE_SidebarHelper();

		// swap long menus with mobile version

		if ( document.querySelector('.site-nav.style--classic > .site-nav-container') ) {
			let classicMenuWidth = 0;
			let iconsMenuWidth = 0;
			document.querySelectorAll('.site-nav.style--classic > .site-nav-container .primary-menu > ul > li').forEach(elm=>{
				classicMenuWidth += elm.offsetWidth;
			});
			document.querySelectorAll('.site-nav .site-menu-handle').forEach(elm=>{
				if ( ! elm.classList.contains('hide') ) {
					iconsMenuWidth += elm.offsetWidth;
				}
			});
			
			if ( classicMenuWidth > document.getElementById('site-header').offsetWidth - 200 - document.querySelector('.logo').offsetWidth - iconsMenuWidth ) {
				document.body.classList.add('switch-menus');
			}
		} 

		// _end of drawers

		/* -- > SUBMENU HELPERS < -- */

		this.siteHeader = document.getElementById('site-header');

		if ( document.querySelector('.site-nav.style--classic') ) {
			const submenuPadding = ( this.siteHeader.offsetHeight - document.querySelector('.site-nav.style--classic').offsetHeight ) / 2;
			const submenuStyle = document.createElement('style');
			submenuStyle.id = 'site-nav-classic';
			submenuStyle.setAttribute('type', 'text/css');
			submenuStyle.innerHTML = '.site-nav.style--classic .submenu { padding-top: ${submenuPadding}px; } .site-nav.style--classic .submenu:after { top: ${submenuPadding}px; height: calc(100% - ${submenuPadding}px) !important; } .site-nav.style--classic .submenu.mega-menu { padding-top: ${submenuPadding+70}px; } .site-nav.style--classic .submenu.mega-menu:after { top: ${submenuPadding}px; }';
			document.getElementsByTagName('head')[0].appendChild(submenuStyle);
		}

		// tab navigation for classic menu ___ TO WORK ON THIS !!!

		document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

			const elm = childEl.parentNode;

			elm.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					if ( ! e.target.classList.contains('no-focus-link') ) {
						e.preventDefault();
					}
					if ( ! elm.classList.contains('focus') ) {
						elm.classList.add('focus');
						elm.setAttribute('aria-expanded', 'true');
					} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
						elm.classList.remove('focus');
						elm.setAttribute('aria-expanded', 'true');
					}
				}
			});	

			if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
				elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
					if ( elm.classList.contains('focus') ) {
						elm.classList.remove('focus');
						elm.setAttribute('aria-expanded', 'false');
					}
				});
			}

		});

		document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

			const elm = childEl.parentNode;

			elm.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					e.preventDefault();
					if ( ! elm.classList.contains('focus') ) {
						elm.classList.add('focus');
						elm.setAttribute('aria-expanded', 'true');
					} else {
						elm.classList.remove('focus');
						elm.setAttribute('aria-expanded', 'false');
					}
				}
			});

			if ( elm.querySelector('.babymenu li:last-child a') ) {
				elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
					if ( elm.parentNode.classList.contains('focus') ) {
						elm.parentNode.classList.remove('focus');
						elm.parentNode.setAttribute('aria-expanded', 'false');
					}
				});
			}

		})

		// sidebar submenus opening

		document.querySelectorAll('.site-nav.style--sidebar .has-submenu:not(.collections-menu)').forEach(elm=>{
			elm.querySelector(':scope > a').addEventListener('click', e=>{
				const parent = e.currentTarget.parentNode;
				if ( ! parent.classList.contains('active') ) {
					e.preventDefault();
					parent.classList.add('active');
					slideDown(parent.querySelector('.submenu'), 200);
					parent.querySelector('.submenu').setAttribute('aria-expanded', 'true');
				} else if ( e.currentTarget.getAttribute('href') == '#' ) {
					e.preventDefault();
					parent.classList.remove('active');
					slideUp(parent.querySelector('.submenu'), 200);
					parent.querySelector('.submenu').setAttribute('aria-expanded', 'false');
					elm.classList.remove('hover');
				}
			});
		})

		document.querySelectorAll('.site-nav.style--sidebar .has-babymenu:not(.collections-menu)').forEach(elm=>{
			elm.querySelector(':scope > a').addEventListener('click', e=>{
				const parent = e.currentTarget.parentNode;
				if ( ! parent.classList.contains('active') ) {
					e.preventDefault();
					parent.classList.add('active');
					slideDown(parent.querySelector('.babymenu'), 200);
					parent.querySelector('.babymenu').setAttribute('aria-expanded', 'true');
				} else if ( e.currentTarget.getAttribute('href') == '#' ) {
					e.preventDefault();
					parent.classList.remove('active');
					slideUp(parent.querySelector('.babymenu'), 200);
					parent.querySelector('.babymenu').setAttribute('aria-expanded', 'false');
					elm.classList.remove('hover');
				}
			})
			
		});

		// _end of submenus

		/* -- > STICKY SIDEBAR < -- */

		if ( document.getElementById('site-header').classList.contains('header-scroll') ) {

			if ( document.body.classList.contains('template-index') ) {
				document.body.classList.add('index-margin-fix');
			}

			window.lst = window.scrollY;
			window.lhp = 0;

          var self = this

			this.SCROLL_StickyHelper = () =>{

				var st = window.scrollY;
              
             
				if ( st < 0 || Math.abs(lst - st) <= 5 ) 
					return;	

				if ( st <= 100 ) {
					this.siteHeader.classList.remove('animate');
					this.siteHeader.classList.remove('fix');
					this.siteHeader.classList.remove('ready');
                    console.log(st + 'scroll top')
				} else {

				 	// if ( st == 0 ) {
                      
						// this.siteHeader.classList.remove('animate');
						// this.siteHeader.classList.remove('fix');
						// this.siteHeader.classList.remove('ready');
                     
      //               }

				 	// } else if ( st <= lst && ! this.siteHeader.classList.contains('fix') ) {
				 		window.lhp = this.siteHeader.offsetTop;
						this.siteHeader.classList.add('fix');
						setTimeout(()=>{
							this.siteHeader.classList.add('ready');
						}, 5);
						setTimeout(()=>{
							this.siteHeader.classList.add('animate');
						}, 25);
                  

					// } else if ( st > lst && this.siteHeader.classList.contains('animate') ) {
					// 	this.siteHeader.classList.remove('animate');
					// 	setTimeout(()=>{
					// 		this.siteHeader.classList.remove('fix');
					// 		this.siteHeader.classList.remove('ready');
					// 	}, 105);
					// }

				}
                 

				window.lst = st;

			}

			window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});

		}

		// _end of stickyness

	}

	unmount(){
		window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		window.removeEventListener('scroll', this.SCROLL_StickyHelper);
	}

}

customElements.define('main-header', MainHeader);

/* 
	* This is the class for modal sidebars
*/

class SidebarDrawer extends HTMLElement {

	constructor(){
		super();
		this.siteOverlay = document.getElementById('site-overlay');
		this.querySelector('.site-close-handle').addEventListener('click', ()=>{
			this.hide();
		});
	}

	show(){
		this.style.display = 'block';
		setTimeout(()=>{
			this.classList.add('active');
		}, 10);
		this.siteOverlay.classList.add('active');
		document.body.classList.add('sidebar-move');
		document.querySelector('html').classList.add('kill-overflow');
		this.style.height = `${window.innerHeight}px`;
		if ( this.id == "site-cart" ) {
			if ( document.querySelector('#cart-recommendations css-slider') ) {
				document.querySelector('#cart-recommendations css-slider').resetSlider();
			}
		}
		this._mountA11YHelper();
	}

	hide(){
		this.classList.remove('active');
		this.siteOverlay.classList.remove('active');
		document.body.classList.remove('sidebar-move');
		document.querySelector('html').classList.remove('kill-overflow');
		setTimeout(()=>{
			this.style.display = 'none';
		}, 250);
		this._unmountA11YHelper();
	}

	/*
		* a11y helpers / tab catcher 
	*/

	_mountA11YHelper(forcedFocus){

		let focusable = forcedFocus ? forcedFocus : this.querySelectorAll('[tabindex="0"], button, [href], input:not([type="hidden"]), select, textarea, .regular-select-cover');

		let firstFocusable = focusable[0];
		let lastFocusable = focusable[focusable.length - 1];

		if ( this.id == 'site-cart' && this.querySelector('.cart-holder').getAttribute('data-items') != '0' ) {
			lastFocusable = focusable[focusable.length - 2];
		}

		this.A11Y_TAB_EVENT = ((firstFocusable, lastFocusable, e)=>{
			let isTabPressed = (e.key === 'Tab' || e.keyCode === window.KEYCODES.TAB);
			if (!isTabPressed) { 
				return; 
			}
			if ( e.shiftKey ) /* shift + tab */ {
				if (document.activeElement === firstFocusable) {
			 		lastFocusable.focus();
					e.preventDefault();
				}
			} else /* tab */ {
				if (document.activeElement === lastFocusable) {
					firstFocusable.focus();
					e.preventDefault();
				}
			}
		}).bind(this, firstFocusable, lastFocusable)

 		this.addEventListener('keydown', this.A11Y_TAB_EVENT);

	}

	_unmountA11YHelper(){
		this.removeEventListener('keydown', this.A11Y_TAB_EVENT);
	}

}

customElements.define('sidebar-drawer', SidebarDrawer);

/* ---
	Announcement bar
--- */

class AnnouncementBar extends HTMLElement {
	constructor(){
		super();
		if ( document.querySelector('.announcement__exit') ) {
			document.querySelector('.announcement__exit').addEventListener('click', ()=>{
				document.body.classList.remove('show-announcement-bar');
				localStorage.setItem('announcement-dismissed', 'true');
				document.querySelector('.site-header').style.marginTop = '0px';
				this.style.display = 'none';
			})
		}

	}
}
customElements.define('announcement-bar', AnnouncementBar);
class CartForm extends HTMLElement {

	constructor(){
		super();
		this.ajaxifyCartItems();
	}

	ajaxifyCartItems(){

		this.form = this.querySelector('form');

		this.querySelectorAll('.cart-item').forEach(item=>{

			const remove = item.querySelector('.remove');
			if ( remove ) {
				remove.dataset.href = remove.getAttribute('href');
				remove.setAttribute('href', '');
				remove.addEventListener('click', (e)=>{
					e.preventDefault();
					this.updateCartQty(item, 0);
				})
			}

			const qty = item.querySelector('.qty');
			if ( qty ) {
				qty.addEventListener('input', debounce(e=>{
					e.preventDefault();
					e.target.blur();
					this.updateCartQty(item, parseInt(qty.value));
				}, 300));
				qty.addEventListener('click', (e)=>{
					e.target.select();
				})
			}

		})

	}

	updateCartQty(item, newQty){

		this.form.classList.add('processing');
		if ( this.querySelector('.alert') ) {
			this.querySelector('.alert').remove();
		}

		const body = JSON.stringify({
			id: item.dataset.id,
			quantity: newQty
		});

		fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body
			})
			.then(response => {
				if ( response.ok ) {
					return fetch('?section_id=cart-helper')
				} else {
					throw new Error('Something went wrong');
				}
			})
			.then(response => response.text())
			.then(text => {

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
				document.querySelector('[data-header-cart-count]').textContent = cartItems.querySelector('[data-cart-count]').textContent;

				if ( newQty == 0 && document.getElementById('cart-recommendations') ) {
					document.getElementById('cart-recommendations').innerHTML = '';
					document.getElementById('cart-recommendations').generateRecommendations();
				}
				
				if ( newQty != 0 && newQty > parseInt(cartItems.querySelector(`.cart-item[data-id="${item.dataset.id}"]`).dataset.qty) ) {
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_add_error.replace('{{ title }}', item.dataset.title);
					this.form.prepend(alert);
				} 

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				window.preloadImages(cartItems);

				if ( document.body.classList.contains('template-cart') ) {
					document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
					if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
						document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
						if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
							document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
						} else {
							document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
						}
					} else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
						document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
					}
				}

			})
			.catch(e => {
				console.log(e);
				let alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = KROWN.settings.locales.cart_general_error;
				this.form.prepend(alert);
			})
			.finally(() => {
				this.form.classList.remove('processing');
			});
	}

} 

customElements.define('cart-form', CartForm);

class CartProductQuantity extends HTMLElement {
	constructor(){
		super();
		this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
		this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
	}
	changeCartInput(){
		setTimeout(()=>{
			document.getElementById('AjaxCartForm').updateCartQty(this.closest('.cart-item'), parseInt(this.querySelector('.qty').value));
		}, 50);
	}
}
customElements.define('cart-product-quantity', CartProductQuantity);

class CartProductRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('.cart-item');
		if ( cartItems.length > 0 ) {
			let recommendationsDOM = document.createElement('div');

			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=cart-recommendations&product_id=${cartItems[0].dataset.productId}&limit=6`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
						.parseFromString(text, 'text/html')
						.querySelector('.cart-product-recommendations');
					if ( innerHTML && innerHTML.querySelectorAll('.cart-product-item').length > 0 ) {
						document.getElementById('cart-recommendations').innerHTML = innerHTML.innerHTML;
					}
				})
		}
	}
}
customElements.define('cart-product-recommendations', CartProductRecommendations);
class QuickAddToCart extends HTMLElement {
	constructor(){
		super();
		if ( this.querySelector('product-form') ) {
			this.init();
		}
	}
	init(){
		this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
			if ( ! document.body.classList.contains('template-cart') ) {
				window.preloadImages(document.getElementById('site-cart'));
	 			document.getElementById('site-cart').show();
	 			if ( document.getElementById('cart-recommendations') ) {
					document.getElementById('cart-recommendations').generateRecommendations();
				}
			} else {
				document.querySelector('#section-cart .box__text').scrollIntoView();
				document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
			}
 		});
	}
}

customElements.define('quick-add-to-cart', QuickAddToCart);

class QuickViewProduct extends HTMLElement {
	constructor(){
		super();
		if ( this.querySelector('a') ) {
			this.init();
		}
	}
	init(){

		this.quickViewModal = null;
		this.querySelector('a').addEventListener('click', (e)=>{

			e.preventDefault();

			if ( ! this.quickViewModal ) {

				const target = e.currentTarget;

				target.classList.add('working');

				fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
					.then(response => response.text())
					.then(text => {

						// create modal w content

						const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-product-quick-view');
						this.quickViewModal = basicLightbox.create(quickViewHTML);
						this.quickViewModal.show();
						this.quickViewModal.element().querySelector('.basicLightboxClose').addEventListener('click', ()=>{
							this.quickViewModal.close();
						});
						target.classList.remove('working');

						// setup images for variant selector

						const quickProduct = this.quickViewModal.element();
						const quickProductImage = quickProduct.querySelector('.product-images img');

						const quickViewImages = JSON.parse(quickProduct.querySelector('.product-images').querySelector('[type="application/json"]').textContent);

						const productVariants = quickProduct.querySelector('product-variants');
						if ( productVariants ) {
							productVariants.addEventListener('VARIANT_CHANGE', (e)=>{
								const variant = e.target.currentVariant;
								if ( variant && variant.featured_media != null && quickViewImages[variant.id] != null ) {
									quickProductImage.setAttribute('srcset', quickViewImages[variant.id]);
								}
							})
						}

						// setup add to cart functionality

					 	if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				 			let addToCartEnter = false;
							if ( quickProduct.querySelector('.product--add-to-cart-button') ) {
						 		quickProduct.querySelector('.product--add-to-cart-button').addEventListener('keyup', e=>{
									if ( e.keyCode == window.KEYCODES.RETURN ) {
										addToCartEnter = true;
									}
						 		})
						 	}

						 	if ( quickProduct.querySelector('.product--add-to-cart-form') ) {
						 		quickProduct.querySelector('.product--add-to-cart-form').addEventListener('add-to-cart', ()=>{
									window.preloadImages(document.getElementById('site-cart'));
						 			document.getElementById('site-cart').show();
						 			if ( document.getElementById('cart-recommendations') ) {
										document.getElementById('cart-recommendations').generateRecommendations();
									}
						 			if ( addToCartEnter ) {
										setTimeout(()=>{
											document.querySelector('#site-cart .sidebar__cart-close').focus();
										}, 200);
						 			}
						 		});
						 	}

					 	}

					});

			} else {
				this.quickViewModal.show();
			}

		})
	}
}

customElements.define('quick-view-product', QuickViewProduct);
class ProductQuantity extends HTMLElement {

	constructor(){

		super();

		const qty = this.querySelector('.qty-selector'),
					qtyMinus = this.querySelector('.qty-minus'),
					qtyPlus = this.querySelector('.qty-plus'),
					qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
					qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

		if ( parseInt(qty.value) - 1 < qtyMin ) {
			qtyMinus.classList.add('disabled');
		}
		if ( parseInt(qty.value) + 1 > qtyMax ) {
			qtyPlus.classList.add('disabled');
		}

		qtyMinus.addEventListener('click', (e)=>{
			e.preventDefault();
			if ( ! qtyMinus.classList.contains('disabled') ) {
				const currentQty = parseInt(qty.value);
				if ( currentQty - 1 >= qtyMin ) {
					qty.value = currentQty - 1;
					qtyPlus.classList.remove('disabled');
				} 
				if ( currentQty - 1 <= qtyMin ) {
					qtyMinus.classList.add('disabled');
				}
			}
		});

		qtyPlus.addEventListener('click', (e)=>{
			e.preventDefault();
			if ( ! qtyPlus.classList.contains('disabled') ) {
				const currentQty = parseInt(qty.value);
				if ( currentQty + 1 <= qtyMax ) {
					qty.value = currentQty + 1;
					qtyMinus.classList.remove('disabled');
				} 
				if ( currentQty + 1 >= qtyMax ) {
					qtyPlus.classList.add('disabled');
				}
			}
		});

	}
	
}

customElements.define('product-quantity', ProductQuantity);
class ProductModel extends HTMLElement {
	constructor() {
		super();  
		Shopify.loadFeatures([
			{
				name: 'model-viewer-ui',
				version: '1.0',
				onLoad: this.setupModelViewerUI.bind(this),
			},
		]);
	}
	setupModelViewerUI(errors) {
		if (errors) return;
		this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
		const modelViewerEl = this.modelViewerUI.viewer;
		modelViewerEl.addEventListener('shopify_model_viewer_ui_toggle_play', ()=>{
			if ( modelViewerEl.closest('.css-slider-holder') ) {
				modelViewerEl.closest('.css-slider-holder').classList.add('css-slider--disable-dragging');
			}        
		});
		modelViewerEl.addEventListener('shopify_model_viewer_ui_toggle_pause', ()=>{
			if ( modelViewerEl.closest('.css-slider-holder') ) {
				modelViewerEl.closest('.css-slider-holder').classList.remove('css-slider--disable-dragging');
			}        
		});
		if ( modelViewerEl.closest('.product-gallery__item') && modelViewerEl.closest('.product-gallery__item').dataset.index == '0' ) {
			if ( modelViewerEl.closest('.css-slider-holder') ) {
				modelViewerEl.closest('.css-slider-holder').classList.add('css-slider--disable-dragging');
			}  
		}
	}
}
customElements.define('product-model', ProductModel);

window.ProductModel = {
	loadShopifyXR() {
		Shopify.loadFeatures([
			{
				name: 'shopify-xr',
				version: '1.0',
				onLoad: this.setupShopifyXR.bind(this),
			},
		]);
	},

	setupShopifyXR(errors) {
		
		if (errors) return;
		if (!window.ShopifyXR) {
			document.addEventListener('shopify_xr_initialized', () =>
				this.setupShopifyXR()
			);
			return;
		}
		document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
			window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
			modelJSON.remove();
		});
		window.ShopifyXR.setupXRElements();
	}
};
class SiteFilterHandle extends HTMLElement {
	constructor(){
		super();
		const sidebarFilters = document.getElementById('site-filters');
		this.addEventListener('click', e=>{
			e.preventDefault();
			this.setAttribute('aria-expanded', 'true');
			sidebarFilters.show();
		})
		this.addEventListener('keyup', e=>{
			if ( e.keyCode == window.KEYCODES.RETURN ) {
				sidebarFilters.querySelector('.site-close-handle').focus();
			}
		})
	}
}
customElements.define('site-filter-handle', SiteFilterHandle);

/* ---
	Product Page
--- */

class ProductPage extends HTMLElement {
		constructor() {
			if (super(), !this.hasAttribute("data-empty-product")) {
				this.productGallery = this.querySelector(".product-gallery"), this.productSlider = this.querySelector("css-slider"), this.querySelector(".product-gallery__thumbnails .thumbnail") && (this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach((e, t) => {
						0 == t && e.classList.add("active"), e.addEventListener("click", e => {
								this.productSlider.sliderEnabled ? this.productSlider.changeSlide(e.currentTarget.dataset.index) : (window.scrollTo({
										top: this.productGallery.querySelector(`.product-gallery-item[data-faux-index="${e.currentTarget.hasAttribute("data-faux-index")?e.currentTarget.dataset.fauxIndex:e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
										behavior: "smooth"
								}), this.thumbnailNavigationHelper(e.currentTarget.dataset.fauxIndex)), pauseAllMedia()
						})
				}), this.productSlider.addEventListener("change", e => {
						this.thumbnailNavigationHelper(e.target.index)
				})), this.productSlider.addEventListener("navigation", e => {}), this.productSlider.addEventListener("change", e => {
						"model" == this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType && this.xrButton && this.xrButton.setAttribute("data-shopify-model3d-id", this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId), pauseAllMedia(), this.thumbnailNavigationHelper(e.target.index)
				});

				const e = this.querySelector("product-variants");
				if (e && (e.addEventListener("VARIANT_CHANGE", this.onVariantChangeHandler.bind(this)), this.onVariantChangeHandler({
								target: e
						})), !document.body.classList.contains("template-cart") && "overlay" == KROWN.settings.cart_action) {
						let e = !1;
						this.querySelector(".product--add-to-cart-button") && this.querySelector(".product--add-to-cart-button").addEventListener("keyup", t => {
								t.keyCode == window.KEYCODES.RETURN && (e = !0)
						}), this.querySelector(".product--add-to-cart-form") && this.querySelector(".product--add-to-cart-form").addEventListener("add-to-cart", () => {
								window.preloadImages(document.getElementById("site-cart")), document.getElementById("site-cart").show(), document.getElementById("cart-recommendations") && document.getElementById("cart-recommendations").generateRecommendations(), e && setTimeout(() => {
										document.querySelector("#site-cart .sidebar__cart-close").focus()
								}, 200)
						})
				}

				if ("scroll" == this.productGallery.dataset.style) {
						this.productGalleryNavigation = this.querySelector(".product-gallery__thumbnails"), this.productGalleryNavigationItem = this.querySelectorAll(".product-gallery__thumbnails .thumbnail");
						const e = [...this.productGallery.querySelectorAll(".product-gallery-item")].reverse(),
								t = this.parentNode == document.querySelector("#main .mount-product-page:first-child") && document.querySelector("#main .mount-product-page:first-child .product-gallery__thumbnails");
						this.GALLERY_NAVIGATION_SCROLL = () => {
								if (!this.productGallery.querySelector("css-slider").sliderEnabled && window.innerWidth > 768) {
										for (const t of e) {
												const e = t.getBoundingClientRect().top;
												if (e < window.innerHeight / 2 && e > -window.innerHeight / 2) {
														this.productGalleryNavigationItem.forEach(e => e.classList.remove("active")), this.productGalleryNavigationItem[t.dataset.fauxIndex].classList.add("active");
														break
												}
										}
										const r = this.productGallery.getBoundingClientRect().top; - 1 * (r - window.innerHeight) > this.productGallery.offsetHeight ? (this.productGalleryNavigation.classList.add("scroll"), this.productGalleryNavigation.classList.remove("scroll-up")) : r > 0 ? (this.productGalleryNavigation.classList.add("scroll-up"), this.productGalleryNavigation.classList.add("scroll"), t && (t.style.height = `calc( var(--window-height) + ${window.scrollY}px )`)) : -1 * (r - window.innerHeight) < this.productGallery.offsetHeight && (this.productGalleryNavigation.classList.remove("scroll"), this.productGalleryNavigation.classList.remove("scroll-up"))
								}
						}, window.addEventListener("scroll", this.GALLERY_NAVIGATION_SCROLL, {
								passive: !0
						}), this.GALLERY_NAVIGATION_SCROLL()
				}

				if ("slider" == this.productGallery.dataset.style) {
						const e = document.querySelector("#main .mount-product-page:first-child");
						this.GALLERY_NAVIGATION_SCROLL = () => {
								const t = this.productGallery.getBoundingClientRect().top;
								t > 0 ? (this.productGallery.classList.add("nav-scroll"), e && e.querySelector(".css-slider-navigation-container") && (e.querySelector(".css-slider-navigation-container").style.height = `calc( var(--window-height) + ${window.scrollY}px )`)) : t < 0 && (this.productGallery.classList.remove("nav-scroll"), this.productGallery.classList.remove("nav-scroll-up"))
						}, window.addEventListener("scroll", this.GALLERY_NAVIGATION_SCROLL, {
								passive: !0
						}), this.GALLERY_NAVIGATION_SCROLL()
				}

				this.querySelectorAll("product-model").length > 0 && (window.ProductModel.loadShopifyXR(), this.xrButton = this.querySelector(".product__view-in-space"));
				const t = this.querySelector(".box__product-content"),
						r = this.querySelector(".box__product-gallery");
				this.CONTENT_STICKY_RESIZE = () => {
						t.style.top = `calc(100vh - ${t.offsetHeight}px)`, r.style.top = `calc(100vh - ${r.offsetHeight}px)`
				}, window.addEventListener("resize", this.CONTENT_STICKY_RESIZE, {
						passive: !0
				}), this.CONTENT_STICKY_RESIZE();

				if (new MutationObserver(e => {
								for (const t of e) this.CONTENT_STICKY_RESIZE()
						}).observe(t, {
								attributes: !0,
								childList: !0,
								subtree: !0
						}), this.productGallery.querySelector("video-popup")) {
						const e = new MutationObserver(e => {
								for (const t of e) t.target.classList.contains("video-opened") ? this.productGallery.classList.add("remove-navigation") : this.productGallery.classList.remove("remove-navigation")
						});
						this.productGallery.querySelectorAll("video-popup").forEach(t => {
								e.observe(t, {
										attributes: !0,
										childList: !1,
										subtree: !1
								})
						})
				}

				if( document.querySelector( '.js-nav-tabs' ) ) {
					this.activeTab = ''
					this.bind()
				}

				// if only one tab, automatically show that
				const tabPanes = this.querySelectorAll('.tab-content .tab-pane')
				if( 1 === tabPanes.length ) {
					const activePane = tabPanes[0]

					activePane.classList.add( 'active' )
					activePane.classList.add( 'show' )
				}
			}
		}


		bind() {
			this.addTabListeners()

			document.querySelectorAll('.js-nav-link-tab').forEach( el => {
				el.addEventListener( 'click', this.handleNavTabClick.bind( this ) )
			})

			document.addEventListener( 'DOMContentLoaded', this.showTabOnPageLoad.bind( this ) )
		}


		addTabListeners() {
			const $ = jQuery

			const $productSlider = $('css-slider')
			const $productThumbnails = $('.product-gallery__thumbnails')
			const $cylindoSlider = $('product-cylindo')
			
			$('#nav-custom-tab').on( 'click', () => {
				$productSlider.show()
				$productThumbnails.show()
				$cylindoSlider.hide()
			});

			$('#nav-instock-tab').on( 'click', () => {
				$productSlider.hide()
				$productThumbnails.hide()
				$cylindoSlider.show()
				$cylindoSlider.get( 0 ).runCylindo()
			});
		}


		handleNavTabClick( e ) {
			const targetTab = e.target.getAttribute( 'id' )

			if( 'nav-custom-tab' === targetTab ) {
				this.activeTab = 'custom'
			} else if( 'nav-instock-tab' === targetTab ) {
				this.activeTab = 'instock'
			} else {
				return
			}

			// actually handling tab content change handled elsewhere
			this.updateTabQueryParam()
			this.updateBodyClass()
		}


		showTabOnPageLoad() {
			let targetTab = 'custom'
			const url = new URL( window.location )

			if( url.searchParams.get( 'tab' ) ) {
				targetTab = url.searchParams.get( 'tab' )
			}

			this.updateActiveTab( targetTab )
		}


		updateActiveTab( targetTab ) {
			if( targetTab === this.activeTab ) {
				return
			}
			this.activeTab = targetTab

			this.updateTabStates()
			this.updateTabQueryParam()
		}


		updateTabStates() {
			this.querySelectorAll( '.nav-link' ).forEach( el => {
				const elId = el.getAttribute( 'id' )
				const isActive = ( 'custom' === this.activeTab && 'nav-custom-tab' === elId ) || ( 'instock' === this.activeTab && 'nav-instock-tab' === elId )
	
				el.classList.toggle( 'active', isActive )
	
				if( isActive ) {
					$(el).trigger('click')
				}
			})
	
			this.querySelectorAll('.tab-content .tab-pane').forEach( el => {
				const elId = el.getAttribute( 'id' )
				const isActive = ( 'custom' === this.activeTab && 'nav-custom' === elId || ( 'instock' === this.activeTab && 'nav-instock' === elId ) )
	
				el.classList.toggle( 'active', isActive )
				el.classList.toggle( 'show', isActive )
			})
		}

		
		updateTabQueryParam() {
			const url = new URL( window.location )
			const paramTab = url.searchParams.get( 'tab' )

			if( paramTab !== this.activeTab ) {
				url.searchParams.set( 'tab', this.activeTab )
				window.history.pushState( '', '', url.toString() )
			}
		}

		
		updateBodyClass() {
			const classToAdd = `active-tab--${this.activeTab}`

			document.body.classList.forEach( className => {
				if( className.startsWith( 'active-tab--' ) ) {
					document.body.classList.remove( className )
				}
			})

			document.body.classList.add( classToAdd )
		}		


		thumbnailNavigationHelper(e = 0) {
				this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach((t, r) => {
						r == e ? t.classList.add("active") : t.classList.remove("active")
				})
		}
		onVariantChangeHandler(e) {
				const t = e.target.currentVariant;
				if (t && null != t.featured_media) {
						const e = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + t.featured_media.id + '"]');
						if (e)
								if ("slider" == this.productGallery.dataset.style || "scroll" == this.productGallery.dataset.style && this.productGallery.querySelector("css-slider").sliderEnabled) this.productGallery.querySelector("css-slider").changeSlide(e.dataset.index);
								else {
										[...this.productGallery.querySelectorAll(".product-gallery-item")].sort((e, t) => e.dataset.index - t.dataset.index).forEach(e => {
												this.productGallery.querySelector("css-slider").append(e)
										}), this.productGallery.querySelector("css-slider").prepend(e), this.reorderThumbnailNavigation()
								}
				}
		}
		reorderThumbnailNavigation(e) {
				const t = [...this.productGallery.querySelectorAll(".product-gallery-item")].reverse(),
						r = this.querySelector(".product-gallery__thumbnails .thumbnails-holder .thumbnails");
				t.forEach(e => {
						r.prepend(this.querySelector(`.product-gallery__thumbnails .thumbnail[data-faux-index="${e.dataset.index}"]`))
				}), this.querySelectorAll(".product-gallery__thumbnails .thumbnails-holder .thumbnail").forEach((e, t) => {
						e.setAttribute("data-index", t)
				}), this.thumbnailNavigationHelper(0), setTimeout(() => {
						this.thumbnailNavigationHelper(0)
				}, 10)
		}
}
customElements.define("product-page", ProductPage);


/* ---
	Product Reviews
--- */

class ProductReviews {

	constructor(_this){
		this.reviewContainer = _this

		// hide review section unless there are at least three reviews
		_this.classList.add( 'hide--important' )

		const observer = new MutationObserver((mutations, observer)=>{
			for ( const mutation of mutations ) {
				if ( mutation.addedNodes.length > 0 ) {
					mutation.addedNodes.forEach(elm=>{
						if ( elm.tagName == 'DIV' && elm.classList.contains('spr-container') ) {
							this.init(elm);
							observer.disconnect();
						} 
					});
				}
			}
		})

		_this.classList.add('observe-reviews');

		if ( _this.querySelector('.spr-review') ) {
			this.init(_this.querySelector('.spr-container'))
		} else {
			observer.observe(_this, {childList: true})
		}
	}

	init(elm){
		elm.closest('#shopify-product-reviews').classList.remove('observe-reviews');

		// redo reviews title

		const ratingTextEl = document.querySelector('.product__price-reviews .rating-text');

		if ( document.querySelector('#shopify-product-reviews .spr-summary-starrating') ) {
			document.querySelector('#shopify-product-reviews .spr-summary-starrating').prepend(
				this.createRatingEl(
					document.querySelector('.spr-summary-starrating'), 'spr-custom-rating', (ratingTextEl ? ratingTextEl.textContent : '')
				)
			);
		}

		// recreate section structure

		elm.classList = "site-box-container container--fullscreen box--can-stick site-box-container--flex";

		const reviewsHeader = elm.querySelector('.spr-header');
		if ( reviewsHeader ) {
			reviewsHeader.classList = "site-box box--big box--flexible lap--box--small-fl palm--box--small-fl box--typo-big box--center-align box--column-flow box__heading";
			reviewsHeader.setAttribute('data-order', '0');
			reviewsHeader.style.borderBottom = "none";
			reviewsHeader.innerHTML = `<div class="site-box-content" 
				style="display:flex;flex-direction:column"
			>${ reviewsHeader.innerHTML }</div>`;
			reviewsHeader.querySelector('.spr-header-title').classList = "h1 title";
			reviewsHeader.querySelector('.spr-summary-actions-newreview').classList.add("button");
			reviewsHeader.querySelector('.spr-summary-actions-newreview').classList.add("button--solid");
		}

		const reviewsContent = elm.querySelector('.spr-content');
		if ( reviewsContent ) {
			reviewsContent.classList = "site-box box--big box--flexible lap--box--bigger box__text box--typo-big box--center-align box--column-flow";
			reviewsContent.setAttribute('data-order', '1');
			if ( reviewsContent.querySelector('.spr-reviews').children.length <= 0 ) {
				reviewsContent.querySelector('.spr-reviews').innerHTML = `<p class="text-size--larger">${KROWN.settings.locales.product_no_reviews}</p>`;
				reviewsContent.querySelector('.spr-reviews').style.display = "block";
				reviewsHeader.querySelector('.spr-summary-caption').remove();
			}
			reviewsContent.querySelector('.spr-reviews').classList = "site-box-content";
		}

		// turn form into popup

		const reviewForm = document.createElement('div');
		reviewForm.id = 'spr-form-modal';
		reviewForm.innerHTML = `<div id="spr-form" class="spr-form-holder address-popup">
			<div class="basicLightboxClose">×</div>
		</div>`;
		
		const reviewModalForm = basicLightbox.create(reviewForm);
		document.querySelector('.spr-summary-actions-newreview').setAttribute('onclick', '');

		// alternate "Write a Review" button
		document.querySelectorAll('.spr-summary-starrating').forEach( el => {
			const writeReviewBtn = document.createElement('button')
			writeReviewBtn.innerText = 'Write a review'
			writeReviewBtn.classList.add( 'write-review-link' )

			el.insertAdjacentElement( 'beforeend', writeReviewBtn )

			writeReviewBtn.addEventListener('click', e=>{
				e.preventDefault();
				reviewModalForm.show(()=>{
					if ( reviewModalForm.element().querySelector('.basicLightboxClose') ) {
						reviewModalForm.element().querySelector('.basicLightboxClose').addEventListener('click', ()=>{
							reviewModalForm.close();
						});
					}
				})
			})			
		})

		document.querySelector('.spr-summary-actions-newreview').addEventListener('click', e=>{
			e.preventDefault();
			reviewModalForm.show(()=>{
				if ( reviewModalForm.element().querySelector('.basicLightboxClose') ) {
					reviewModalForm.element().querySelector('.basicLightboxClose').addEventListener('click', ()=>{
						reviewModalForm.close();
					});
				}
			})
		})

		reviewModalForm.element().querySelector('.spr-form-holder').prepend(elm.querySelector('.spr-form'));
		reviewModalForm.element().querySelector('.spr-form').style.display = 'block';
		reviewModalForm.element().querySelector('.spr-button').classList = "button button--solid";

		// recreate reviews & pagination

		this.redoReviews(elm);
	 // this.redoPagination(elm);

	} 

	redoReviews(elm) {
		elm.querySelectorAll('.spr-review').forEach(review=>{
			review.querySelector('.spr-review-header').insertBefore(this.createRatingEl(review, 'spr-review-custom-rating'), review.querySelector('.spr-review-header').firstElementChild.nextSibling);
		});

		// show review container if three or more reviews
		if( 3 <= elm.querySelectorAll('.spr-review').length ) {
			this.reviewContainer.classList.remove( 'hide--important')
		} else {
			const link = document.querySelector('.product-header .spr-summary-starrating .link.underlined-link' )
			if( link ) {
				const span = document.createElement('span')
				span.innerHTML = link.innerHTML

				link.parentNode.replaceChild( span, link )
			}
		}

		const reviewsPagination = elm.querySelector('.spr-pagination');
		if ( reviewsPagination ) {
			reviewsPagination.querySelector('div').classList = "pagination pagination--small";
			if ( reviewsPagination.querySelector('.spr-pagination-prev') ) {
				reviewsPagination.querySelector('.spr-pagination-prev a').innerHTML = `<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1.46442 7.94185L0.0502109 6.52764L6.53549 0.0423586L7.94971 1.45657L1.46442 7.94185Z" fill="#262627"/>
							<path d="M0.0503636 6.49961L1.46458 5.0854L7.94986 11.5707L6.53564 12.9849L0.0503636 6.49961Z" fill="#262627"/>
						</svg>`;
			}

			if ( reviewsPagination.querySelector('.spr-pagination-next') ) {
				reviewsPagination.querySelector('.spr-pagination-next a').innerHTML = `<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.53557 5.08537L7.94979 6.49958L1.46451 12.9849L0.0502931 11.5706L6.53557 5.08537Z" fill="#262627"/>
						<path d="M7.94964 6.52761L6.53542 7.94182L0.050142 1.45654L1.46436 0.0423289L7.94964 6.52761Z" fill="#262627"/>
					</svg>`;
			}
		}

		if ( this.reviewsObserver ) {
			this.reviewsObserver.disconnect();
		}

		this.reviewsObserver = new MutationObserver((mutations, observer)=>{
			for ( const mutation of mutations ) {
				this.redoReviews(elm);
			}
		})
		this.reviewsObserver.observe(elm, {childList: true, subtree: true})

	}

	createRatingEl(elm, className, textContent=""){
		let ra = elm.querySelectorAll('.spr-icon-star').length,
					rb = elm.querySelectorAll('.spr-icon-star-half-alt').length > 0 ? '.5' : '',
	 				ratingEl = document.createElement('span');

		if( 0 === ra ) {
			const altRa = elm.querySelector('.spr-stars')

			if( altRa ) {
				ra = altRa.querySelectorAll('.spr-star').length
			}
		}

		ratingEl.classList = `${className} text-size--regular fjfdvnjdfvnvdjfnj`;
		ratingEl.innerHTML = `<span>${ textContent != "" ? textContent : `${(ra + rb)} / 5` }</span>${KROWN.settings.symbols.star}`;
		return ratingEl;
	}

}

if ( document.getElementById('shopify-product-reviews') ) {
	new ProductReviews(document.getElementById('shopify-product-reviews'));
}
class CountdownClock extends HTMLElement {

	constructor(){

		super();

		this.daysEl = this.querySelector('.days');
		this.hoursEl = this.querySelector('.hours');
		this.minutesEl = this.querySelector('.minutes');
		this.secondsEl = this.querySelector('.seconds');

		const date = this.dataset.date.split(',');
		this.COUNT = new Date(date[0], (date[1]-1), date[2], date[3]);

		const gmt = parseInt(this.dataset.timezone);
		const timezone = this.COUNT.getTimezoneOffset() / -60;

		if ( timezone != gmt ) {
			this.COUNT.setHours(parseInt(date[3]) + timezone - gmt );
		} 

		this._countdownBannerInterval = setInterval(this._countEachSecond.bind(this), 1000);
		this._countEachSecond();
		if ( this.classList.contains('hide') ) {
			this.classList.remove('hide');
		}

	}

	_countEachSecond(){

		const now = new Date().getTime(),
			distance = this.COUNT - now;

		const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
			hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
			minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
			seconds = Math.floor((distance % (1000 * 60)) / 1000);

		this.daysEl.innerHTML = days < 10 ? `<span>0</span><span>${days}</span>` : days.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
		this.hoursEl.innerHTML = hours < 10 ? `<span>0</span><span>${hours}</span>` : hours.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
		this.minutesEl.innerHTML = minutes < 10 ? `<span>0</span><span>${minutes}</span>` : minutes.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
		this.secondsEl.innerHTML = seconds < 10 ? `<span>0</span><span>${seconds}</span>` : seconds.toString().split('').map(digit=>`<span>${digit}</span>`).join("");

		if ( distance < 0 ) {
			clearInterval(this._countdownBannerInterval);
			this.daysEl.innerHTML = '<span>0</span><span>0</span>';
			this.hoursEl.innerHTML = '<span>0</span><span>0</span>';
			this.minutesEl.innerHTML = '<span>0</span><span>0</span>';
			this.secondsEl.innerHTML = '<span>0</span><span>0</span>';
		}
	}

}
customElements.define('countdown-clock', CountdownClock);
window.lightMapStyle=[{featureType:"water",elementType:"geometry",stylers:[{color:"#e9e9e9"},{lightness:17}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:20}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:18}]},
{featureType:"road.local",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:16}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:21}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#dedede"},{lightness:21}]},{elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#ffffff"},{lightness:16}]},{elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#333333"},{lightness:40}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},
{featureType:"transit",elementType:"geometry",stylers:[{color:"#f2f2f2"},{lightness:19}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#fefefe"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#fefefe"},{lightness:17},{weight:1.2}]}];

window.darkMapStyle=[{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#000000"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#000000"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#000000"},
{lightness:17},{weight:1.2}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#000000"},{lightness:21}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#000000"},
{lightness:18}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#000000"},{lightness:16}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#000000"},{lightness:19}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#000000"},{lightness:17}]}];

class ContactMap extends HTMLElement {

	constructor(){
		super();
		this.mount();
	}

	mount(){
		
		if ( this.dataset.address != "" ) {
			if ( typeof google !== 'undefined' && google.maps ) {
				this._createMap();
			} else {
				if ( window.loadingGoogleMapsScript ) {
					this.ti = setInterval(()=>{
						if ( typeof google !== 'undefined' ) {
							clearInterval(this.ti);
							this._createMap();
						}
					}, 100);
				} else {
					window.loadingGoogleMapsScript = true;
					var googleScript = document.createElement('script');
					googleScript.onload = (()=>{
						this._createMap();
					});
					googleScript.async = true
					googleScript.src = `https://maps.googleapis.com/maps/api/js?v=3&key=${this.dataset.key}`;
					document.head.appendChild(googleScript);
				}

			}

		}
	}

	_createMap(){

		const mapEl = this.querySelector('.contact-map-object'),
			mapDetails = this.querySelector('.contact-map-address-holder');

		const coordsKey = `map-coords-${mapEl.id}`;

		let coordsStorage = localStorage.getItem(coordsKey) != null ? JSON.parse(localStorage.getItem(coordsKey)) : null,
			mapLat = 0,
			mapLong = 0;

		if ( coordsStorage != null && coordsStorage['address'] == mapEl.dataset.address ) {
			mapLat = coordsStorage['lat'];
			mapLong = coordsStorage['long'];
		}

	 	let geocoder, map, address;

		geocoder = new google.maps.Geocoder();
		address = mapEl.dataset.address;

		const mapOptions = {
			zoom: parseInt(mapEl.dataset.zoom),
			center: new google.maps.LatLng(mapLat, mapLong),
			streetViewControl: false,
			scrollwheel: false,
			panControl: true,
			mapTypeControl: false,
			overviewMapControl: false,
			zoomControl: true,
			draggable: true,
			styles: mapEl.dataset.style == 'light' ? window.lightMapStyle : window.darkMapStyle
		};			

		map = new google.maps.Map(document.getElementById(mapEl.id), mapOptions);

		if ( mapLat != 0 || mapLong != 0 ) {

			const markerOptions = {
				position: new google.maps.LatLng(mapLat, mapLong),
				map: map, 
				title: address
			}

			if( mapEl.dataset.marker != 'none' ) {
				markerOptions['icon'] = {
					url: mapEl.dataset.marker,
					scaledSize: new google.maps.Size(60, 60)
				}
			}

			mapDetails.querySelector('a').setAttribute('href', `http://www.google.com/maps/place/${mapLat},${mapLong}`);
			const contentString = mapDetails.innerHTML;
			const infowindow = new google.maps.InfoWindow({
				content: contentString
			});

			const marker = new google.maps.Marker(markerOptions); 
			marker.addListener('click', ()=>{
				infowindow.open(map, marker);
				if ( window.innerWidth < 480 ) {
					document.querySelector('.template-page-contact .box__heading .title').style.marginTop = '50px';
				} else if ( window.innerWidth < 768 ) {
					document.querySelector('.template-page-contact .box__heading .title').style.marginTop = '100px';
				}
			});

			if ( window.innerWidth > 768 ) {
				map.panBy(-150, 150);
			} else {
				map.panBy(-75, 75);
			}

		} else {

			if ( geocoder ) {

				geocoder.geocode( { 'address': address }, (results, status)=>{

					if (status == google.maps.GeocoderStatus.OK) {
						if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {

							map.setCenter(results[0].geometry.location);

							const markerOptions = {
								position: results[0].geometry.location,
								map: map, 
								title: address
							}

							if( mapEl.dataset.marker != 'none' ) {
								markerOptions['icon'] = {
									url: mapEl.dataset.marker,
									scaledSize: new google.maps.Size(60, 60)
								}
							}

							mapDetails.querySelector('a').setAttribute('href', `http://www.google.com/maps/place/${results[0].geometry.location.lat()},${results[0].geometry.location.lng()}`);
							const contentString = mapDetails.innerHTML;

							const infowindow = new google.maps.InfoWindow({
								content: contentString
							});

							const marker = new google.maps.Marker(markerOptions); 
							marker.addListener('click', ()=>{
								infowindow.open(map, marker);
							});

							if ( window.innerWidth > 768 ) {
								map.panBy(-150, 150);
							} else {
								map.panBy(-75, 75);
							}
							
							localStorage.setItem(coordsKey, JSON.stringify({
								'address': mapEl.dataset.address,
								'lat': results[0].geometry.location.lat(),
								'long': results[0].geometry.location.lng()
							}));

						} else {
							alert("No results found for the given address");
						}
					} else {
						console.log("Geocode was not successful for the following reason: " + status);
					}

				});

	 		}

	 	}

	}

}
customElements.define('contact-map', ContactMap);
class SplitScreenSlider extends CSSSlider {

	constructor(){
		super();

		this.mount();
		this.RESIZE_SliderHelper = debounce(()=>{
			this.unmount();
			this.mount();
		}, 300);
		window.addEventListener('resize', this.RESIZE_SliderHelper, {passive:true});

	}

	mount(){

		this._currentScroll = window.scrollY;
		this._headerHeight = document.getElementById('site-header').offsetHeight;

		this._fullWidth = this.classList.contains('layout-full') ? true : false;

		this._scrollEnabled = true;

		this._screenHeight = Math.min(window.innerHeight, window.screen.availHeight);

		this.slides = this.querySelectorAll('.slider-item'),
		this.slidesMedia = this.querySelectorAll('.slider-item-media > div');
		this.slidesBlackArray = this.querySelectorAll('.slider-item-media-overlay');
		this.headings = this.querySelectorAll('.box__heading');

		this.slides.forEach((elm, key)=>{
			if ( key == 0 || window.scrollY >= this._getOffsetTop(elm) ) {
				this.slidesMedia[key].style.height = `100%`;
			} else {
				this.slidesMedia[key].style.height = `0`;
			}
			window.preloadImages(elm);
		});

		this.addEventListener('ready', ()=>{
			this.slides = this.querySelectorAll('.slider-item');
			this.slidesMediaElements = this.querySelectorAll('.slider-item-media-element');
			this.addEventListener('scroll', ()=>{
				const scrollX = -this.element.scrollLeft;
				this.slides.forEach((slide,i)=>{
					const media = this.slidesMediaElements[i];
					if ( media ) {
						media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
					}
				});
			});
		});

		let previous = -1,
			currentOld = -1;

		this.SCROLL_SliderHelper = () => {

			const scrollTop = window.scrollY >= 0 ? window.scrollY : 0;
			const sliderTop = this._getOffsetTop(this);

			if ( this._scrollEnabled ) {

				let current = 0;

				if ( scrollTop + this._headerHeight - this._headerHeight < this._getOffsetTop(this) && ! this.classList.contains('back-to-normal') ) {
					this.classList.add('back-to-normal');
				}

				this.slides.forEach((elm, key)=>{
					if ( this._checkVisible(elm) ) {
						current = key;
					}
				});

				if ( current != currentOld ) {
					if ( this._currentScroll < scrollTop && currentOld > 0 ) {
						this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], this._screenHeight);
					} else if ( this._currentScroll > window.scrollY && currentOld > 0 ) {
						this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], 0);
					}
					currentOld = current;
					previous = current-1;
				}

				if ( current == 0 && scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
					this.classList.add('back-to-normal');
				} else if ( current > 0 ) {

					const scrollValue = ( scrollTop - sliderTop ) - this._screenHeight * ( current - 1 );
					if ( ! this.classList.contains('back-to-normal') ) {
						this._scrollMedia( current, this.slides[current], this.slides[previous], this.slidesMedia[current], this.slidesBlackArray[previous], scrollValue);

					}
					if ( scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
						this.classList.add('back-to-normal');
					} else if ( scrollTop + this._screenHeight < sliderTop + this.offsetHeight && this.classList.contains('back-to-normal' ) ) {
						this.classList.remove('back-to-normal');
					}

				}

			}

			this._currentScroll = scrollTop;

		}

		window.addEventListener('scroll', this.SCROLL_SliderHelper, {passive:true});
		this.SCROLL_SliderHelper();

	}

	unmount() {
		window.removeEventListener('scroll', this.SCROLL_SliderHelper);
	}

	_scrollMedia(index, currentSlide, previousSlide, currentSlideMedia, previousSlideOverlay, scrollValue) {

		if ( this._fullWidth ) {
			currentSlideMedia.style.clipPath = `polygon(0 ${window.innerHeight - scrollValue + 1}px, 100% ${window.innerHeight - scrollValue + 1}px, 100% 100%, 0% 100%)`;
		} else {
			currentSlideMedia.style.height = `${scrollValue}px`;
		}

		console.log("currentSlideMedia", currentSlideMedia);

		if ( previousSlideOverlay ) {
			// previousSlideOverlay.style.opacity = `${Math.ceil( scrollValue * 30 / this._screenHeight ) / 100}`;
			previousSlideOverlay.style.opacity = 0;
			console.log("HERE in previous slide overlay.");
		}

	}

	_checkVisible(elm) {
		// return true;
		const rect = elm.getBoundingClientRect();
		const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
		return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
	}

	_getOffsetTop(elm) {
		if (!elm.getClientRects().length) {
			return 0;
		}
		const rect = elm.getBoundingClientRect();
		const win = elm.ownerDocument.defaultView;
		return rect.top + win.pageYOffset;
	}

}
customElements.define('split-screen-slider', SplitScreenSlider);



class VideoCustomElement extends HTMLElement {
	constructor(){
		super();
		const video = this.querySelector('video');
		if ( ! video.paused || video.readyState >= 2 ) {
			this.classList.add('loaded');
		} else {
			this.fallbackT = setTimeout((video=>{
				if ( video.paused ) {
					const fallback = this.closest('.slider-item-media').querySelector('img');
					this.remove();
					ribSetSize(fallback);
				}
			}).bind(this, video), 3000);
			video.addEventListener('canplay', e=>{
				this.classList.add('loaded');
				clearTimeout(this.fallbackT);
			});
		}
	}
}
customElements.define('video-custom-element', VideoCustomElement);
class VideoModalPopup extends HTMLElement {
	constructor(){
		super();
		const modal = basicLightbox.create(`<div class="video-popup-holder" data-video-type="${this.dataset.videoType}" style="padding-top: 56.25%">
				${this.querySelector('template').content.firstElementChild.innerHTML}
				<div class="basicLightboxClose">${KROWN.settings.symbols.close}</div>
			</div>`, {
			onShow: instance=>{
				setTimeout((instance=>{
					switch ( instance.element().querySelector('.video-popup-holder').dataset.videoType ) {
						case "youtube":
							instance.element().querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
							break;
						case "vimeo":
							instance.element().querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
							break;
					}
				}).bind(this, instance), 500);
				instance.element().querySelector('.basicLightboxClose').addEventListener('click', ()=>{
									instance.close();
									
				})
			}
		});

		this.addEventListener('click', e=>{
			e.preventDefault();
			modal.show();
					$("body,html").css("overflow","hidden");
					
		});

	}
}
customElements.define('video-modal-popup', VideoModalPopup);
KROWN.themeName = 'Split';
KROWN.themeVersion = '3.1.0';

const executeOnceOnDomContentLoaded = ()=>{

	// fit video aspect

	reframe(document.querySelectorAll('.rte iframe[src*="youtube"], .rte iframe[src*="vimeo"]'));

	// tab navigation

	let activeElement = document.activeElement;
	document.addEventListener('keyup', e=>{
		if ( e.keyCode == window.KEYCODES.TAB ) {
			if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
				activeElement.classList.remove('focus');
			}
			if ( e.target.classList.contains('product-variant__input') ||
				e.target.classList.contains('button') ||
				e.target.classList.contains('product-item') ||
				e.target.classList.contains('spr-summary-actions-newreview') ||
				e.target.classList.contains('site-box-content-to-focus')
			) {
				e.target.classList.add('focus');
			} 
			activeElement = document.activeElement;
		}
	});

	// newsletter has jump

	if ( window.location.pathname.includes('/challenge') ) {
		setTimeout(()=>{
			window.scroll({
				top: 0, 
				behavior: 'auto'
			});
		}, 300);
	}

	// fix image link borders

	document.querySelectorAll('.rte a img').forEach(elm=>{
		elm.parentNode.style.border = 'none';
	});

	// fix quick add to cart

	setTimeout(()=>{
		if ( document.querySelector('modal-box quick-view-product') ) {
			document.querySelector('modal-box quick-view-product').init();
		}
		if ( document.querySelector('modal-box quick-add-to-cart') ) {
			document.querySelector('modal-box quick-add-to-cart').init();
			document.querySelector('modal-box product-form').init();
		}
	}, 3050);

}

if ( document.readyState !== 'loading' ) {
	executeOnceOnDomContentLoaded();
} else {
	document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}



// Lightbox
var $overlay = $('<div id="overlay"></div>');
var $image = $("<picture><img></picture>");
var $prevButton = $('<div id="prevButton"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg></div>');
var $nextButton = $('<div id="nextButton"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#fff" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg></div>');
//var $exitButton = $('<div id="exitButton"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/><path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/></svg></div>');

// Add overlay
$overlay.append($image).prepend($prevButton).append($nextButton);
$("#gallery").append($overlay);

// Hide overlay on default
$overlay.hide();

// When an image is clicked
$(".img-overlay").click(function(event) {
	// Prevents default behavior
	event.preventDefault();
	// Adds href attribute to variable
	var imageLocation = $(this).prev().prev().prev().attr("srcset");
	var urls = imageLocation.replace(/\s+[0-9]+(\.[0-9]+)?[wx]/g, "").split(/,/);
	var lastUrl = urls.slice(-1).pop();
	console.log(lastUrl);
	// Add the image src to $image
	$image.find("img").attr("src", lastUrl);
	$image.find("img").attr("galleryindex", $(this).parent().parent().attr("imageindex"));
	// Fade in the overlay
	$overlay.fadeIn(300);
	$("body,html,#site-overlay").css("overflow","hidden");
});

// When the overlay is clicked
$overlay.click(function() {
	// Fade out the overlay
	$(this).fadeOut(300);
	$("body,html,#site-overlay").css("overflow","revert");
});



// When next button is clicked
$nextButton.click(function(event) {
	// Hide the current image
	$("#overlay img").hide();
	// Overlay image location
	var $currentImgIndex = $("#overlay img").attr("galleryindex");
	// Image with matching location of the overlay image
	var $currentImg = $('#gallery').find('div[imageindex="' + $currentImgIndex + '"]');
	// Finds the next image
	var $nextImg = $($currentImg.next().find("img"));
	// All of the images in the gallery
	var $images = $("#image-gallery img");
	// If there is a next image
	if ($nextImg.length > 0) { 
		// Fade in the next image
		var imageLocation = $nextImg.attr("srcset");
		var urls = imageLocation.replace(/\s+[0-9]+(\.[0-9]+)?[wx]/g, "").split(/,/);
		var lastUrl = urls.slice(-1).pop();
		$("#overlay img").attr("src", lastUrl).fadeIn(300);
		$("#overlay img").attr("galleryindex", $nextImg.parent().parent().attr("imageindex"));
	} else {
		// Otherwise fade in the first image
		var imageLocation = $($images[0]).attr("srcset");
		var urls = imageLocation.replace(/\s+[0-9]+(\.[0-9]+)?[wx]/g, "").split(/,/);
		var lastUrl = urls.slice(-1).pop();
		$("#overlay img").attr("src", lastUrl).fadeIn(300);
		$("#overlay img").attr("galleryindex", "1");
	}
	// Prevents overlay from being hidden
	event.stopPropagation();
});

// When previous button is clicked
$prevButton.click(function(event) {
	// Hide the current image
	$("#overlay img").hide();
	// Overlay image location
	var $currentImgIndex = $("#overlay img").attr("galleryindex");
	// Image with matching location of the overlay image
	var $currentImg = $('#gallery').find('div[imageindex="' + $currentImgIndex + '"]');;
	// Finds the next image
	var $nextImg = $($currentImg.prev().find("img"));
	// Fade in the next image
	if ($nextImg.length > 0) { 
		// Fade in the next image
		var imageLocation = $nextImg.attr("srcset");
		var urls = imageLocation.replace(/\s+[0-9]+(\.[0-9]+)?[wx]/g, "").split(/,/);
		var lastUrl = urls.slice(-1).pop();
		$("#overlay img").attr("src", lastUrl).fadeIn(300);
		$("#overlay img").attr("galleryindex", $nextImg.parent().parent().attr("imageindex"));
	} else {
		// Otherwise fade in the first image
		var imageLocation = $($images[0]).attr("srcset");
		var urls = imageLocation.replace(/\s+[0-9]+(\.[0-9]+)?[wx]/g, "").split(/,/);
		var lastUrl = urls.slice(-1).pop();
		$("#overlay img").attr("src", lastUrl).fadeIn(300);
		$("#overlay img").attr("galleryindex", $("div[imageindex]").last().attr("imageindex"));
	}
	// Prevents overlay from being hidden
	event.stopPropagation();
});

window.addEventListener('scroll', () => {
	document.documentElement.style.setProperty('--scroll-y', '${window.scrollY}px');
});

jQuery(document).ready(function( $ ) {
	jQuery('#ContactFormPhone').mask('000-000-0000');
	
	// FitVids - responsive videos
	if( 'function' === typeof $.fn.fitVids ) {
		$('body.template-page-video-gallery').fitVids();
	}

    //Finishes toggle
    // let width = $(window).width();

    // if(width < 768){
    //   $('h2.finish-swatch-library__headline').click(function(){
    //       $(this).parent().toggleClass('collapse');
    //       $(this).next().slideToggle();
    //   });
    // }
  
});

jQuery(document).ready(function( $ ) {
$('.newsroom-container').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    mobileFirst: true,
    nextArrow: '<span class="slider-arrow arrow-next">❯</span>',
    prevArrow: '<span class="slider-arrow arrow-prev">❮</span>',
    responsive: [
            {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
            }
          },
          {
                  breakpoint: 1024,
                  settings: 'unslick'
          }
    ]
  });
});

($ => {

	const BackToTop = {
		$btn: null,
		$windows: null,
		$mobileSize: 1024,
		init() {
			this.$btn = $('.js-back-to-top');
			this.$windows = $(window);

			if (this.$btn.length) {
				this.bind();
			}
		},

		bind() {

			this.maybeShowButton();

			this.$windows.on('scroll', this.maybeShowButton.bind(this));

			this.$btn.on('click', this.scrollToTop);
		},

		maybeShowButton() {

			if (this.$windows.width() > this.$mobileSize) {
				return;
			}

			let $scrollableBtns = this.$btn.filter('.js-back-to-top--scrollable');
			let $docHeight = this.$windows.height();
			let $footer = $('#section-footer');
			let $footerTop = $footer.offset().top;

			// Toggle 'show-up' class based on scroll position
			let isScrolledPastHalf = this.$windows.scrollTop() > $docHeight / 2;
			let isFooterNotInView = this.$windows.scrollTop() + this.$windows.height() <= $footerTop;

			$scrollableBtns.toggleClass('show-up', isScrolledPastHalf && isFooterNotInView);
		},

		scrollToTop() {
			$('html, body').animate({ scrollTop: 0 }, 200);
		}
	};

	BackToTop.init()

})(jQuery);


/**
 * Add "loading" spinner to forms when submitting
 * 
 */
( $ => {
	$(document).on( 'submit', 'form', e => {
		const $form = $(e.currentTarget)
		
		if( /extforms.netsuite.com/.test( $form.prop( 'action' ) ) ) {
			$form.addClass( 'is-submitting' )
			$form.find('button[type="submit"]').addClass( 'is-submitting' )
		}
	})
}) ( jQuery );


// apply Slick to images at top of blog posts
( $ => {

	$( () => {
		$('.article-image-slider').slick({
			prevArrow: '<button type="button" class="article-image-slider-btn article-image-slider-btn--prev slick-prev"><svg width="22" height="34" version="1.1" viewBox="0 0 1.0312 1.5938" xmlns="http://www.w3.org/2000/svg"><path d="m0.092719 0.90318 0.62631 0.60148a0.15658 0.15037 0 0 0 0.2214-0.21262l-0.51561-0.49517 0.51561-0.49517a0.15658 0.15037 0 0 0-0.2214-0.21262l-0.62631 0.60148a0.15658 0.15037 0 0 0 0 0.21262z" fill="#fff" /></svg></button>',
			nextArrow: '<button type="button" class="article-image-slider-btn article-image-slider-btn--next slick-next"><svg width="22" height="34" version="1.1" viewBox="0 0 1.0312 1.5938" xmlns="http://www.w3.org/2000/svg"><path d="m0.93853 0.69056-0.62631-0.60148a0.15658 0.15037 0 0 0-0.2214 0.21262l0.51561 0.49517-0.51561 0.49517a0.15658 0.15037 0 0 0 0.2214 0.21262l0.62631-0.60148a0.15658 0.15037 0 0 0 0-0.21262z" fill="#fff"/></svg></button>',
		})
	})

}) ( jQuery );


( $ => {

	$('video').on( 'play', e => {
		const $target = $(e.currentTarget)

		$target.closest('#video-popup--').addClass('video-is-playing')
	})

}) ( jQuery )



// jQuery Mask Plugin v1.14.16
// github.com/igorescobar/jQuery-Mask-Plugin
var $jscomp=$jscomp||{};$jscomp.scope={};$jscomp.findInternal=function(a,n,f){a instanceof String&&(a=String(a));for(var p=a.length,k=0;k<p;k++){var b=a[k];if(n.call(f,b,k,a))return{i:k,v:b}}return{i:-1,v:void 0}};$jscomp.ASSUME_ES5=!1;$jscomp.ASSUME_NO_NATIVE_MAP=!1;$jscomp.ASSUME_NO_NATIVE_SET=!1;$jscomp.SIMPLE_FROUND_POLYFILL=!1;
$jscomp.defineProperty=$jscomp.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,n,f){a!=Array.prototype&&a!=Object.prototype&&(a[n]=f.value)};$jscomp.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};$jscomp.global=$jscomp.getGlobal(this);
$jscomp.polyfill=function(a,n,f,p){if(n){f=$jscomp.global;a=a.split(".");for(p=0;p<a.length-1;p++){var k=a[p];k in f||(f[k]={});f=f[k]}a=a[a.length-1];p=f[a];n=n(p);n!=p&&null!=n&&$jscomp.defineProperty(f,a,{configurable:!0,writable:!0,value:n})}};$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(a,f){return $jscomp.findInternal(this,a,f).v}},"es6","es3");
(function(a,n,f){"function"===typeof define&&define.amd?define(["jquery"],a):"object"===typeof exports&&"undefined"===typeof Meteor?module.exports=a(require("jquery")):a(n||f)})(function(a){var n=function(b,d,e){var c={invalid:[],getCaret:function(){try{var a=0,r=b.get(0),h=document.selection,d=r.selectionStart;if(h&&-1===navigator.appVersion.indexOf("MSIE 10")){var e=h.createRange();e.moveStart("character",-c.val().length);a=e.text.length}else if(d||"0"===d)a=d;return a}catch(C){}},setCaret:function(a){try{if(b.is(":focus")){var c=
b.get(0);if(c.setSelectionRange)c.setSelectionRange(a,a);else{var g=c.createTextRange();g.collapse(!0);g.moveEnd("character",a);g.moveStart("character",a);g.select()}}}catch(B){}},events:function(){b.on("keydown.mask",function(a){b.data("mask-keycode",a.keyCode||a.which);b.data("mask-previus-value",b.val());b.data("mask-previus-caret-pos",c.getCaret());c.maskDigitPosMapOld=c.maskDigitPosMap}).on(a.jMaskGlobals.useInput?"input.mask":"keyup.mask",c.behaviour).on("paste.mask drop.mask",function(){setTimeout(function(){b.keydown().keyup()},
100)}).on("change.mask",function(){b.data("changed",!0)}).on("blur.mask",function(){f===c.val()||b.data("changed")||b.trigger("change");b.data("changed",!1)}).on("blur.mask",function(){f=c.val()}).on("focus.mask",function(b){!0===e.selectOnFocus&&a(b.target).select()}).on("focusout.mask",function(){e.clearIfNotMatch&&!k.test(c.val())&&c.val("")})},getRegexMask:function(){for(var a=[],b,c,e,t,f=0;f<d.length;f++)(b=l.translation[d.charAt(f)])?(c=b.pattern.toString().replace(/.{1}$|^.{1}/g,""),e=b.optional,
(b=b.recursive)?(a.push(d.charAt(f)),t={digit:d.charAt(f),pattern:c}):a.push(e||b?c+"?":c)):a.push(d.charAt(f).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"));a=a.join("");t&&(a=a.replace(new RegExp("("+t.digit+"(.*"+t.digit+")?)"),"($1)?").replace(new RegExp(t.digit,"g"),t.pattern));return new RegExp(a)},destroyEvents:function(){b.off("input keydown keyup paste drop blur focusout ".split(" ").join(".mask "))},val:function(a){var c=b.is("input")?"val":"text";if(0<arguments.length){if(b[c]()!==a)b[c](a);
c=b}else c=b[c]();return c},calculateCaretPosition:function(a){var d=c.getMasked(),h=c.getCaret();if(a!==d){var e=b.data("mask-previus-caret-pos")||0;d=d.length;var g=a.length,f=a=0,l=0,k=0,m;for(m=h;m<d&&c.maskDigitPosMap[m];m++)f++;for(m=h-1;0<=m&&c.maskDigitPosMap[m];m--)a++;for(m=h-1;0<=m;m--)c.maskDigitPosMap[m]&&l++;for(m=e-1;0<=m;m--)c.maskDigitPosMapOld[m]&&k++;h>g?h=10*d:e>=h&&e!==g?c.maskDigitPosMapOld[h]||(e=h,h=h-(k-l)-a,c.maskDigitPosMap[h]&&(h=e)):h>e&&(h=h+(l-k)+f)}return h},behaviour:function(d){d=
d||window.event;c.invalid=[];var e=b.data("mask-keycode");if(-1===a.inArray(e,l.byPassKeys)){e=c.getMasked();var h=c.getCaret(),g=b.data("mask-previus-value")||"";setTimeout(function(){c.setCaret(c.calculateCaretPosition(g))},a.jMaskGlobals.keyStrokeCompensation);c.val(e);c.setCaret(h);return c.callbacks(d)}},getMasked:function(a,b){var h=[],f=void 0===b?c.val():b+"",g=0,k=d.length,n=0,p=f.length,m=1,r="push",u=-1,w=0;b=[];if(e.reverse){r="unshift";m=-1;var x=0;g=k-1;n=p-1;var A=function(){return-1<
g&&-1<n}}else x=k-1,A=function(){return g<k&&n<p};for(var z;A();){var y=d.charAt(g),v=f.charAt(n),q=l.translation[y];if(q)v.match(q.pattern)?(h[r](v),q.recursive&&(-1===u?u=g:g===x&&g!==u&&(g=u-m),x===u&&(g-=m)),g+=m):v===z?(w--,z=void 0):q.optional?(g+=m,n-=m):q.fallback?(h[r](q.fallback),g+=m,n-=m):c.invalid.push({p:n,v:v,e:q.pattern}),n+=m;else{if(!a)h[r](y);v===y?(b.push(n),n+=m):(z=y,b.push(n+w),w++);g+=m}}a=d.charAt(x);k!==p+1||l.translation[a]||h.push(a);h=h.join("");c.mapMaskdigitPositions(h,
b,p);return h},mapMaskdigitPositions:function(a,b,d){a=e.reverse?a.length-d:0;c.maskDigitPosMap={};for(d=0;d<b.length;d++)c.maskDigitPosMap[b[d]+a]=1},callbacks:function(a){var g=c.val(),h=g!==f,k=[g,a,b,e],l=function(a,b,c){"function"===typeof e[a]&&b&&e[a].apply(this,c)};l("onChange",!0===h,k);l("onKeyPress",!0===h,k);l("onComplete",g.length===d.length,k);l("onInvalid",0<c.invalid.length,[g,a,b,c.invalid,e])}};b=a(b);var l=this,f=c.val(),k;d="function"===typeof d?d(c.val(),void 0,b,e):d;l.mask=
d;l.options=e;l.remove=function(){var a=c.getCaret();l.options.placeholder&&b.removeAttr("placeholder");b.data("mask-maxlength")&&b.removeAttr("maxlength");c.destroyEvents();c.val(l.getCleanVal());c.setCaret(a);return b};l.getCleanVal=function(){return c.getMasked(!0)};l.getMaskedVal=function(a){return c.getMasked(!1,a)};l.init=function(g){g=g||!1;e=e||{};l.clearIfNotMatch=a.jMaskGlobals.clearIfNotMatch;l.byPassKeys=a.jMaskGlobals.byPassKeys;l.translation=a.extend({},a.jMaskGlobals.translation,e.translation);
l=a.extend(!0,{},l,e);k=c.getRegexMask();if(g)c.events(),c.val(c.getMasked());else{e.placeholder&&b.attr("placeholder",e.placeholder);b.data("mask")&&b.attr("autocomplete","off");g=0;for(var f=!0;g<d.length;g++){var h=l.translation[d.charAt(g)];if(h&&h.recursive){f=!1;break}}f&&b.attr("maxlength",d.length).data("mask-maxlength",!0);c.destroyEvents();c.events();g=c.getCaret();c.val(c.getMasked());c.setCaret(g)}};l.init(!b.is("input"))};a.maskWatchers={};var f=function(){var b=a(this),d={},e=b.attr("data-mask");
b.attr("data-mask-reverse")&&(d.reverse=!0);b.attr("data-mask-clearifnotmatch")&&(d.clearIfNotMatch=!0);"true"===b.attr("data-mask-selectonfocus")&&(d.selectOnFocus=!0);if(p(b,e,d))return b.data("mask",new n(this,e,d))},p=function(b,d,e){e=e||{};var c=a(b).data("mask"),f=JSON.stringify;b=a(b).val()||a(b).text();try{return"function"===typeof d&&(d=d(b)),"object"!==typeof c||f(c.options)!==f(e)||c.mask!==d}catch(w){}},k=function(a){var b=document.createElement("div");a="on"+a;var e=a in b;e||(b.setAttribute(a,
"return;"),e="function"===typeof b[a]);return e};a.fn.mask=function(b,d){d=d||{};var e=this.selector,c=a.jMaskGlobals,f=c.watchInterval;c=d.watchInputs||c.watchInputs;var k=function(){if(p(this,b,d))return a(this).data("mask",new n(this,b,d))};a(this).each(k);e&&""!==e&&c&&(clearInterval(a.maskWatchers[e]),a.maskWatchers[e]=setInterval(function(){a(document).find(e).each(k)},f));return this};a.fn.masked=function(a){return this.data("mask").getMaskedVal(a)};a.fn.unmask=function(){clearInterval(a.maskWatchers[this.selector]);
delete a.maskWatchers[this.selector];return this.each(function(){var b=a(this).data("mask");b&&b.remove().removeData("mask")})};a.fn.cleanVal=function(){return this.data("mask").getCleanVal()};a.applyDataMask=function(b){b=b||a.jMaskGlobals.maskElements;(b instanceof a?b:a(b)).filter(a.jMaskGlobals.dataMaskAttr).each(f)};k={maskElements:"input,td,span,div",dataMaskAttr:"*[data-mask]",dataMask:!0,watchInterval:300,watchInputs:!0,keyStrokeCompensation:10,useInput:!/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent)&&
k("input"),watchDataMask:!1,byPassKeys:[9,16,17,18,36,37,38,39,40,91],translation:{0:{pattern:/\d/},9:{pattern:/\d/,optional:!0},"#":{pattern:/\d/,recursive:!0},A:{pattern:/[a-zA-Z0-9]/},S:{pattern:/[a-zA-Z]/}}};a.jMaskGlobals=a.jMaskGlobals||{};k=a.jMaskGlobals=a.extend(!0,{},k,a.jMaskGlobals);k.dataMask&&a.applyDataMask();setInterval(function(){a.jMaskGlobals.watchDataMask&&a.applyDataMask()},k.watchInterval)},window.jQuery,window.Zepto);
/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});

/*! Slick Slider */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

document.addEventListener("DOMContentLoaded", function () {
  const formStore = new WeakMap(); // form -> { realToken, ts, blocked }
  const MIN_SECONDS = 3;           // adjust as needed
  const HONEYPOT_EXPECTED = "I am a human";

  // ✅ Crypto-secure token generation
  function generateToken() {
    const array = new Uint8Array(16); // 16 bytes = 128 bits
    crypto.getRandomValues(array);
    return Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
  }

  function showSpamError(form, text = "Submission rejected. Please complete the form normally.") {
    let errorMsg = form.querySelector(".spam-error-msg");
    if (!errorMsg) {
      errorMsg = document.createElement("div");
      errorMsg.className = "spam-error-msg";
      errorMsg.style.color = "red";
      errorMsg.style.marginBottom = "1rem";
      errorMsg.style.fontWeight = "bold";
      errorMsg.style.fontSize = "1rem";
      form.prepend(errorMsg);
    }
    errorMsg.innerText = text;
  }

  function initForm(form) {
    if (!form || !(form instanceof Element)) return;

    const realToken = generateToken();
    formStore.set(form, { realToken, ts: Date.now(), blocked: false });
    form.dataset.spamProtected = "true";

    // Honeypot: user must type "I am a human"
    const honeypot = form.querySelector(".must-fill input");
    if (honeypot) {
      honeypot.placeholder = 'Type "I am a human"';
    }

    // Hidden _rf_token
    let hidden = form.querySelector("input[name='_rf_token']");
    if (!hidden) {
      hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "_rf_token";
      form.appendChild(hidden);
    }
    hidden.value = realToken;

    // Hidden reCAPTCHA v3 token (unused, left for compatibility)
    // let recaptchaInput = form.querySelector("input[name='g-recaptcha-response']");
    // if (!recaptchaInput) {
    //   recaptchaInput = document.createElement("input");
    //   recaptchaInput.type = "hidden";
    //   recaptchaInput.name = "g-recaptcha-response";
    //   form.appendChild(recaptchaInput);
    // }
  }

  function initDynamicContainer(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const tryInit = () => {
      const form = container.querySelector(".g-container");
      if (form) initForm(form);
      else {
        let tries = 0;
        const poll = setInterval(() => {
          tries++;
          const f = container.querySelector(".g-container");
          if (f) {
            initForm(f);
            clearInterval(poll);
          } else if (tries > 10) {
            clearInterval(poll);
          }
        }, 200);
      }
    };

    container.addEventListener("shown.bs.modal", tryInit);
    tryInit();
  }

  // Initialize existing forms
  document.querySelectorAll(".g-container").forEach(initForm);

  // Observe dynamically added forms
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const added of m.addedNodes) {
        if (added.nodeType !== 1) continue;
        const el = added;
        if (el.matches && el.matches(".g-container")) {
          initForm(el);
          continue;
        }
        const nested = el.querySelectorAll && el.querySelectorAll(".g-container");
        if (nested && nested.length) nested.forEach(initForm);
        const parentForm = el.closest && el.closest(".g-container");
        if (parentForm) initForm(parentForm);
      }
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });

  // Modal IDs
  const modalIds = [
    "div-class-globo-formbuilder-data-id-mtizmda0-div",
    "formbuilder-mtizmda0"
  ];
  modalIds.forEach(initDynamicContainer);

  // Submit handler
  document.addEventListener("submit", function (e) {
    const targetForm = e.target instanceof HTMLFormElement
      ? e.target
      : (e.target && e.target.closest ? e.target.closest(".g-container") : null);

    if (!targetForm || targetForm.dataset.spamProtected !== "true") return;

	console.log("target form = " + target_form)

	// 🔹 Clear previous spam error messages before processing new submission
  	const oldError = targetForm.querySelector(".spam-error-msg");
  	if (oldError) oldError.remove();

    const store = formStore.get(targetForm);
    if (!store) return;

    const honeypot = targetForm.querySelector(".must-fill input");
    const honeypotVal = honeypot ? honeypot.value.trim() : "";
    const postedTokenInput = targetForm.querySelector("input[name='_rf_token']");
    const postedToken = postedTokenInput ? postedTokenInput.value.trim() : "";
    const timeSpentSeconds = (Date.now() - store.ts) / 1000;

    if (store.blocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showSpamError(targetForm, "This form is blocked due to suspicious activity. Please refresh the page.");
      return false;
    }

    // ZIP code validation (optional)
    const zipInput = targetForm.querySelector("input[name='text-3']");
    const zipVal = zipInput ? zipInput.value.trim() : "";
    const zipIsValid = /^\d{5}$/.test(zipVal);
    if (!zipIsValid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showSpamError(targetForm, "Please enter a valid 5-digit ZIP code.");
      if (zipInput) zipInput.focus();
      return false;
    }

    console.log("[DEBUG] Honeypot value:", honeypotVal, "Expected:", HONEYPOT_EXPECTED);
    console.log("[DEBUG] Posted token:", postedToken, "Expected token:", store.realToken);
    console.log("[DEBUG] Time spent on form (seconds):", timeSpentSeconds, "Minimum required:", MIN_SECONDS);

    // 🚨 Spam conditions
    if (
      honeypotVal !== HONEYPOT_EXPECTED ||
      postedToken !== store.realToken ||
      timeSpentSeconds < MIN_SECONDS
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      store.blocked = true;
      showSpamError(targetForm, `Please type exactly: "${HONEYPOT_EXPECTED}"`);
      return false;
    }

    // Passed all checks — allow submit
    store.blocked = true;

    // reCAPTCHA intentionally disabled
    // targetForm.submit(); <-- let browser handle normal submit
  }, true);

  // Optional API to re-init forms
  window.__spamProtect = {
    reinitAll: () => document.querySelectorAll(".g-container").forEach(initForm),
  };

});

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/products/')) {
    const link = document.querySelector('link[href*="theme-styles.min.css"]');
    if (link) link.remove();
  }
  const button = document.querySelector(
    ".rf-btn-primary.rf-btn-primary2"
  );

  if (!button) return;

  const label = button.querySelector(".add-to-cart__text");
  if (!label) return;

  const updateButtonState = () => {
    const text = label.textContent.trim().toLowerCase();

    if (text === "not in stock") {
      button.disabled = true;
      button.classList.add("rf-btn-disabled");
      button.setAttribute("aria-disabled", "true");
      button.removeAttribute("data-bs-toggle");
      button.removeAttribute("data-bs-target");
    } else {
      button.disabled = false;
      button.classList.remove("rf-btn-disabled");
      button.removeAttribute("aria-disabled");
      button.setAttribute("data-bs-toggle", "modal");
      button.setAttribute("data-bs-target", "#RequestAQuoteModal");
    }
  };

  // Run once on load
  updateButtonState();

  // Watch for text changes
  const observer = new MutationObserver(updateButtonState);

  observer.observe(label, {
    characterData: true,
    childList: true,
    subtree: true
  });
});

(function () {
    var FIELD = 'incomingmessage';
    var DEFAULT_TEXT = 'USER DID NOT ENTER DATA';

    function messageField(form) {
      if (!form || form.id !== 'appointment-form') return null;
      return form.querySelector('[name="' + FIELD + '"]');
    }

    function fillIncomingMessage(form) {
      var field = messageField(form);
      if (!field) return;
      if (!String(field.value || '').trim()) {
        field.value = DEFAULT_TEXT;
      }
    }

    /*
      Register on window during parse, in the capture phase, so this runs
      before later submit handlers read or post the form. A bubble listener
      registered on DOMContentLoaded is too late for that path.
    */
    window.addEventListener('submit', function (event) {
      fillIncomingMessage(event.target);
    }, true);

    document.addEventListener('DOMContentLoaded', function () {
      var field = messageField(document.getElementById('appointment-form'));
      if (field) field.removeAttribute('required');
    });

    document.addEventListener('formdata', function (event) {
      var form = event.target;
      if (!messageField(form)) return;
      if (!(event.formData.get(FIELD) || '').trim()) {
        event.formData.set(FIELD, DEFAULT_TEXT);
      }
    }, true);

    var nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      fillIncomingMessage(this);
      return nativeSubmit.call(this);
    };
  })
();
